/* eslint-disable no-template-curly-in-string */
export default {
  featured: 'Featured',
  popular: 'Popular',
  couponsAndDeals: 'Coupons and Deals',
  yourFavorites: 'Your Favorites',
  coupons: 'Coupons',
  headerCoupons: 'Karma | Coupons',
  lastSaved: 'Last Saved',
  favorites: 'Favorites',
  trending: 'Trending',
  weAreLoving: "We're Loving",
  karmaHome: 'Karma | Home',
  goodMorning: 'Good morning',
  goodAfternoon: 'Good afternoon',
  goodEvening: 'Good evening',
  addFavoriteStores: 'Add Favorite Stores',
  nothingFound: 'Nothing found',
  number: '{{value, number}}',
  clearNumber: '{{value, clearNumber}}',
  saveSettings: 'Save Settings',
  enableBrand: 'Enable {{name}}',
  chrome: 'Chrome',
  edge: 'Edge',
  firefox: 'Firefox',
  ie: 'Internet Explorer',
  oldEdge: 'Edge',
  opera: 'Opera',
  safari: 'Safari',
  remove: 'Remove',
  sponsored: 'Sponsored',
  seeAll: 'See all',
  favorite: 'Favorite',
  onSale: 'On sale',
  lowInStock: 'Low in stock',
  backInStock: 'Back in stock',
  coupon: 'Coupon',
  soldOut: 'Sold Out',
  fulfilled: 'Fulfilled',
  deal: 'Deal',
  price: '{{currency}}{{value, number(minimumFractionDigits: 2)}}',
  karmaStores: 'Cash Back Stores',
  priceLeftToWithdraw: 'Only {{currency}}{{value, number}} left to go to withdraw your rewards.',
  fullPrice: '{{currency}}{{value, number}}.{{fraction, fraction}}',
  fraction: '.{{value, fraction}}',
  pendingCash: 'Pending Cash',
  payouts: 'Payouts',
  connectWithPayPal: 'Connect with PayPal',
  selectCause: 'Select Cause',
  dayBetweenPayouts: 'Cash can be withdrawn {{count, number}} day after purchase is confirmed.',
  dayBetweenPayouts_plural: 'Cash can be withdrawn {{count, number}} days after purchase is confirmed.',
  list: 'List:',
  emptyWallet: 'Your wallet is empty',
  startShoppingToEarn: 'Start shopping to earn rewards!',
  withdraw: 'Withdraw',
  yourDonations: 'Your donations',
  outOfAmount: 'Out of {{currency}}{{value, number}}',
  gettingCloser: "You're getting closer!",
  canWithdrawEarnings: 'You can now withdraw your earnings.',
  workedAt: 'Worked {{date}}',
  copied: 'Copied!',
  getCoupon: 'Get Coupon',
  shopNow: 'Shop Now',
  karmaLogo: 'Karma logo',
  stores: 'Stores',
  myLists: 'My Lists',
  uppercase: '{{text, uppercase}}',
  capitalize: '{{text, capitalize}}',
  all: 'All',
  lastWeek: 'Last week',
  lastMonth: 'Last month',
  lastThreeMonths: 'Last 3 months',
  clickID: 'Click ID:',
  date: 'Date',
  time: 'Time',
  retailer: 'Retailer',
  orderID: 'Order ID',
  startShoppingToEarnKarmaCash: 'Start shopping to earn Cash Back,',
  browseStores: 'browse stores',
  doNotHaveClicks: "You don't have any clicks for this time period.",
  doNotHaveTransactions: "You don't have any transactions for this time period.",
  payPalAlt: 'PayPal',
  payPal: 'PayPal:',
  welcomeBonus: 'Welcome bonus!',
  karmaGives: 'Karma Gives!',
  karmaGivesRefund: 'Karma Gives refund!',
  completed: 'Completed',
  notQualified: 'Not qualified',
  pending: 'Pending',
  cancelled: 'Canceled',
  paid: 'Paid',
  empty: 'Empty',
  expired: 'Expired',
  discoverAndShop: 'Discover & Shop',
  contactUs: 'Contact us',
  news: 'News',
  faq: 'FAQ',
  aboutUs: 'About us',
  karmaItem: 'Karma Item',
  email: 'Email',
  congrats: 'Congrats!',
  getKarmaButton: 'Get Karma Button!',
  saveThingsToBuy: 'Save things you want to buy later with Karma!',
  savedFirstItem: 'You have saved your first item!',
  getTheButton: 'Get the Button',
  savedFirstItem_plural: 'You have already saved a few items!',
  iWantToSeeOther: 'I want to see other <1>supported stores</1>',
  neverMissProducts: 'Never miss when products go on sale or come back in stock!',
  shareByEmail: 'Share by Email',
  whenIFindSmth: 'When I find something I want, I save it to Karma!',
  completeSignUp: 'Complete sign up',
  addToList: 'Add to list',
  chat: 'Chat',
  karmaCash: 'Cash Back',
  clickToSaveItem: 'Click to save an item',
  createListAndPressEnter: "Create list and press 'Enter'",
  confirmDeleteProduct: 'Are you sure you want to delete this product?',
  shareOnFacebook: 'Share on Facebook',
  selectAll: 'Select All',
  selectProp: 'Select a {{name}}',
  delete: 'Delete',
  fulfill: 'Fulfill',
  mute: 'Mute',
  anyPriceChange: 'Any price change',
  priceOff: '{{value, number}}% off',
  notifyWhen: 'Notify When',
  tweetOnTwitter: 'Tweet on Twitter',
  shareProduct: 'Share Product',
  markAsFulfilled: 'Mark as fulfilled',
  unmuteNotifications: 'Unmute notifications',
  muteNotifications: 'Mute notifications',
  priceEvolution: 'Price Evolution',
  logOut: 'Log out',
  twitter: 'Twitter',
  facebook: 'Facebook',
  instagram: 'Instagram',
  whatsapp: 'WhatsApp',
  messenger: 'Messenger',
  privacyPolicy: 'Privacy Policy',
  accessibility: 'Accessibility',
  confirmDelete: 'Are you sure you want to delete these products?',
  termsAndConditions: 'Terms and Conditions',
  logosProvidedBy: 'Logos provided by {{name}}',
  copyright: 'Copyright © {{year, clearNumber}} Karma Shopping Ltd., doing business as Karma. All Rights Reserved.',
  noNotifications: 'No notifications',
  clearAllNotifications: 'Clear All Notifications',
  areYouSureRemoveNotifications: 'Are you sure you want to remove all notifications?',
  deleteProducts: 'Delete products',
  no: 'No',
  yes: 'Yes',
  headerStores: 'Karma | Stores',
  clearNotification: 'Clear notification',
  clear: 'Clear',
  bell: 'bell',
  remindInMinute: 'Remind me in {{value, number}} minute',
  remindInMinute_plural: 'Remind me in {{value, number}} minutes',
  remindInHour: 'Remind me in {{value, number}} hour',
  remindInHour_plural: 'Remind me in {{value, number}} hours',
  retailers: 'Retailers',
  claimKarmaCash: 'Claim Up to {{percent, number}}% Cash Back',
  clickOnClaimButton: 'Click the ‘Claim Up to {{percent, number}}% Cash Back’ button.',
  goShopping: 'Go Shopping',
  rackUpCash: 'Rack Up Cash',
  getPaidDirectly: 'Get Paid Directly',
  earnRealMoney: 'Earn real money back on literally every purchase.',
  trackYourEarnings: 'Track your earnings and cash out every season.',
  ordinalNumber: '{{value, fraction}}',
  relatedStores: 'Related Stores',
  defaultWhatHappensNext:
    'To earn Cash Back automatically on your next purchase, click through on one of our eligible Cash Back\n  retailers on Karma, where you can continue to shop as you usually would!\n  Remember, you can only earn Cash Back by visiting the eligible retailer through Karma’s app or\n  dashboard (including push notifications), or by interacting with Karma browser extension on\n  desktop/mobile before purchase.\n  Once the retailer has verified your purchase, Karma will confirm your earnings in your Karma wallet.',
  defaultTermsAndConditions:
    'Cash Back is not available on the purchase of gift cards, or on any portion of a purchase that is paid\n  for with a gift card, store credit or loyalty points or other points program. The use of promotional\n  codes not listed on the Karma website may void Cash Back. Additional restrictions may apply to specific\n  products or categories.',
  whatHappensNext: 'What happens next?',
  about: 'About',
  readMore: 'Read more',
  frequentlyAskedQuestions: 'Frequently Asked Questions',
  loadMore: 'Load More',
  questionButton: 'question button',
  headerKarmaCash: 'Karma | Cash Rewards',
  recommended: 'Recommended',
  highToLow: 'High to Low',
  lowToHigh: 'Low to High',
  sortBy: 'Sort by:',
  exploreStores: 'Explore Stores',
  weHaveNotFoundStores: "We haven't found any stores matching your requests",
  weHaveNotFoundCoupons: "We haven't found any coupons matching your requests",
  headerApps: 'Karma | Apps',
  karmaApps: 'Get good karma, everywhere.',
  stayUpdated:
    'Stay updated across all your devices. Our digital shopping assistant lets you save items from more than {{number, number}}K stores.',
  getFaster: 'Get a faster and smoother experience by downloading Karma to your Mac.',
  headerProfile: 'Karma | Profile',
  headerWallet: 'Karma | Wallet',
  totalBalance: 'Total Balance',
  emailAddress: 'Email Address',
  enterEmailAddress: 'Enter email address',
  enterEmail: 'Enter Email',
  enterEmailLower: 'Enter email',
  phoneNumber: 'Phone Number',
  enterPhoneNumber: 'Enter phone number',
  fullName: 'Full Name',
  enterFullName: 'Enter full name',
  enterPlaceholder: 'Enter {{name}}',
  birthday: 'Birthday',
  year: 'Year',
  month: 'Month',
  day: 'Day',
  gender: 'Gender',
  language: 'Language',
  currency: 'Currency',
  multiCurrency: 'Multi Currency',
  male: 'Male',
  female: 'Female',
  notWantShare: "I don't want to share",
  mobilePush: 'Mobile push',
  webPush: 'Web push',
  disconnectFromPayPal: 'Disconnect from PayPal',
  loginAsUser: 'FUT',
  selectYearAndMonth: 'Please select year and month first',
  notSureWhereToStart: 'Not sure where to start?',
  youDidntSaveItems: "You haven't save any items yet.",
  searchItems: 'Search Items',
  headerDashboard: 'Karma | Dashboard',
  headerSales: 'Karma | Sales',
  couldNotFindStores: "Oops, we couldn't find any sales",
  karmaGivesValue: '${{value, number}}',
  karmaGivesModalTitle: 'Here’s ${{value, number}} FREE to Get You Started',
  hereIsABitOfGoodKarma: 'Here’s a bit of good karma for signing up with us!',
  collectAndStartSaving: 'Collect & Start Saving',
  termsAndConditionsAppersant: 'Terms & Conditions',
  mayApply: 'may apply',
  termsAndConditionsError: 'Please agree first to our terms and privacy policy.',
  validEmailError: 'Please enter a valid email.',
  completeSignUpCapital: 'Complete Sign Up',
  or: 'OR',
  password: 'Password',
  joinUs: 'Join Us',
  reviewsPlus: '{{amount, number}}k+ reviews',
  logIn: 'Log in',
  termsAgreement: 'By signing up, you agree to our <1>Terms</1> and <3>Privacy Policy</3>.',
  termsAgreementWithCheckbox: 'I agree to <1>Terms of Use</1> and <3>Privacy Policy</3>',
  createANewList: 'Create a New List',
  listCreateBlickError: "List name can't be blank",
  enterListName: 'Enter list name',
  listDescriptionOptional: 'List Description (Optional)',
  listName: 'List Name',
  enterDescriptionForList: 'Enter description for your list',
  save: 'Save',
  deleteList: 'Delete List',
  areYouSureRemoveList: 'Are you sure you want to remove this list?',
  editList: 'Edit List',
  listNameCanNotBeBlanck: "List name can't be blank",
  shareList: 'Share List',
  notAMemberCreateAccount: 'Not a member? <1>Create account!</1>',
  backToLogin: 'Back to login',
  enterYourEmail: 'Enter your email address',
  resetPassword: 'Reset password',
  forgotPasswordMessage: "In a few minutes, you'll receive an email with instructions for resetting your password.",
  forgotPassword: 'Forgot password?',
  pleaseScan: 'Please scan',
  saveAnItem: 'Save an item',
  areYouSureFulfilled: 'Are you sure you want to mark as fulfilled these products?',
  muteTagDesc: 'Are you sure you want to mute notifications for these products?',
  muteTagTitle: 'Mute Notifications',
  ok: 'OK',
  ccpaTitle: 'California Consumer Privacy Act (CCPA), as amended by the California Privacy Rights Act (CPRA)',
  ccpaText: ' By submitting this form, I exercise my right to opt-out of any sale of my personal information.',
  submit: 'Submit',
  joinKarmaAndGetRewards: 'Join Karma and Get {{stake, number}} Rewards at {{name}}',
  doNotMissOut: "Don't miss out. You may be able to save money on your item!",
  signUpAndGetMoney: 'Sign Up and Get ${{value, number}}',
  itemAlert: "You've Got an Item Alert!",
  accessKarmaCash: 'Access Your Cash Back',
  youEarnedKarmaCash: 'You Just Earned Cash Back!',
  weHaveSentAnEmailTo: 'We’ve sent you an email to',
  'Fall Favorites': 'Fall Favorites',
  'Karma Cash': 'Cash Back',
  'Clothing & Luxury': 'Clothing & Luxury',
  'Home Decor & Furniture': 'Home Decor & Furniture',
  'Electronics & Office Supplies': 'Electronics & Office Supplies',
  Luxury: 'Luxury',
  Clothing: 'Clothing ',
  'Handbags & Shoes': 'Handbags & Shoes',
  'Jewelry & Watches': 'Jewelry & Watches',
  Accessories: 'Accessories',
  'Beauty Essentials': 'Beauty Essentials',
  'Health & Wellness': 'Health & Wellness',
  Lifestyle: 'Lifestyle',
  'Sports & Outdoors': 'Sports & Outdoors',
  Travel: 'Travel',
  'Electronics & Office supplies': 'Electronics & Office supplies',
  'Entertainment & Online Services': 'Entertainment & Online Services',
  Education: 'Education',
  'Finance & FinTech': 'Finance & FinTech',
  'Pet Supplies': 'Pet Supplies',
  'Food & Beverages': 'Food & Beverages',
  Men: 'Men',
  Women: 'Women',
  Unisex: 'Unisex',
  Kids: 'Kids',
  Baby: 'Baby',
  notifications: 'Notifications',
  changesSaved: 'Changes saved!',
  headerRetailer: 'Karma | Retailer',
  headerRedirect: 'Karma | Redirecting...',
  karma: 'Karma',
  goBackToKarma: 'Back to Karma',
  authentication: 'Authentication',
  authSuccess: 'Congratulations! You have just successfully logged in.',
  authFailure: 'Oops, we could not authorize you. Try again later.',
  mayNotQualify: 'Some products may not qualify for Cash Back',
  checkOutRetailers: 'Check out our supported Cash Back retailers.',
  headerHowItWorks: 'Karma | How It Works',
  accept: 'Accept',
  headerError: 'Karma | Error',
  pageNotFound: 'Page Not Found',
  pageDoesNotExist: "Oops, it looks like this page doesn't exist.",
  backHome: 'Back Home',
  startShopping: 'Start Shopping',
  illustration: 'Illustration',
  dashboard: 'Dashboard',
  allRightsReserved: 'All rights reserved.',
  product: 'Product',
  disclaimer:
    'Karma Shopping Ltd., doing business as Karma. Karma does not have, nor does it purport to have, ownership of third-party trademarks. Third-party trademarks that are visible, or accessible directly or indirectly, via the Karma platform, do not necessarily have a relationship with Karma or third-parties associated with Karma or service providers of Karma.',
  help: 'Help',
  team: 'Team',
  howItWorks: 'How it works',
  supportedStores: 'Supported Stores',
  company: 'Company',
  planYourPurchase: 'Plan your next purchase with our free app!',
  itSitsInBrowser: 'It sits in your web browser while you browse all of your favorite stores.',
  seeSmthYouLike:
    'See something you like? Click the button to save it to your list and Karma will  keep an eye on its price and availability for you.',
  youWillGetNotified:
    "You'll get notified instantly when any of your saved items go on sale, drop in price, or come back in stock in your preferred size and color.",
  everythingYouWant:
    'Everything you want to buy will be in one convenient place, so you can stay organized and stop juggling multiple wishlists.',
  headerContactUs: 'Karma | Contact Us',
  needToGetInTouch: 'Need to get in touch?',
  dropALine: 'Drop Us a Line',
  comeHangOut: 'Come Hang Out',
  joinOurFacebookCommunity: 'Join Our Facebook Community',
  followOnInstagram: 'Follow Us on Instagram',
  headerAboutUs: 'Karma | About Us',
  addTheItems:
    "Add the items you're shopping for - you can customise right down to size and colour - and the app will notify you when they're on sale.",
  jonathanSay:
    'Jonathan: While retailers have been leveraging A.I. for years, it is now the consumer who will capitalize on machine learning and automation tools for efficiency.',
  justDownload:
    "Just download a 'button' and click it when you're on an item you like to save it to your list. On mobile, you can \"share\" items directly to the same lists.",
  ifYouFind:
    "If you find an item you like online that's out of your budget, you can set up a sale alert so that you're notified when the price drops.",
  onlyAHandful:
    'Only a handful of companies offering sale alerts for online members are still standing, including Karma.',
  alwaysBuy: 'Always buy something on sale with Karma.',
  headerCareers: 'Karma | Careers',
  getInTouch: 'Get in touch with us:',
  shop: 'Shop',
  weCouldNotFindResults: "We couldn't find any results for '{{name}}'",
  couldNotFindResults: "We couldn't find any results",
  shopAllStores: 'Shop all supported stores',
  popularStores: 'Popular stores',
  shops: 'Shops',
  headerDiscoverAndShop: 'Karma | Discover and shop the latest saved items',
  prev: 'Prev',
  next: 'Next',
  headerDemo: 'Karma | Demo',
  getTheKarmaButton: 'Get the Karma Button',
  installedKarma: 'You have successfully installed Karma!',
  settingUpAccount: "Now, let's get started by setting up your account.",
  signUpNow: 'Sign Up Now',
  logInNow: 'Log In Now',
  signUpLater: 'Sign up later',
  wePartnerWith: 'We partner with over {{number, number}}K+ online stores!',
  pickStoresToSee: 'Pick one of the stores below to see how it works:',
  leaveKarma: 'Note that you will leave Karma and go to the store page to get the full experience.',
  searchFavoriteStores: 'Search Your Favorite Stores',
  clickBelowToStart: 'Click below to start',
  chooseOneOfTheOptions: 'Choose one of the options below',
  clickToBegin: 'Click the search bar to begin',
  preferNotToSay: 'I prefer not to say',
  done: 'Done',
  headerUnsubscribe: 'Karma | Unsubscribe',
  changeMind: 'Change your mind?',
  resubscribeList: 'Resubscribe to your mailing list.',
  resubscribeList_plural: 'Resubscribe to your mailing list here.',
  changePreferencesAtAnyTime: 'You can also change your preferences at any time through your<1>account settings.</1>',
  preferencesUpdated: "We've updated your email preferences.",
  sorryToSeeYouGo: "We're sorry to see you go!",
  reSubscribed: "You've been re-subscribed",
  allowHours: 'Please allow up to {{hours, number}} hours for the changes to take effect.',
  missWhenYouGone:
    "We'll miss you when you're gone! Please allow up to {{hours, number}} hours for the changes to take effect.",
  headerDisablingSubscribe: 'Karma | Disabling Subscribe',
  noLongerAlerts: 'You will no longer receive alerts for this item.',
  turnAlertsBack: 'Turn alerts back on.',
  moveAnimations: 'Move button animation',
  headerExtensionDeleted: 'Karma | Extension deleted',
  areSorryToSeeYouGo: "We're sorry to see you go!",
  youHaveGotInYourWallet: "You've got ${{value}} in your Wallet.",
  toWithdraw: ' to withdraw your earnings!',
  toContinue: ' to continue earning rewards!',
  reasonUninstalled: "Please let us know why you've uninstalled:",
  getInTouchBtn: 'Get in touch',
  howWeCanIncrease: "Here's How You Can Increase Awareness and Drive Sales by Advertising with Karma",
  helpingShoppers:
    "Helping shoppers discover brands they'll love for years to come is one of our biggest priorities as a personal shopping assistant.",
  whyWeOfferBrands:
    "That's why we offer brands that consistently deliver high customer satisfaction multiple ways to connect with our audience. You get to meet your campaign goals and our audience gets to meet their new favorite brand.",
  winWin:
    'We offer brands that consistently deliver high customer satisfaction multiple ways to connect with our audience. You get to meet your campaign goals and our audience gets to meet their new favorite brand—a true win-win!',
  getFeaturedRight: 'Get featured right inside our app and browser extension dashboard',
  getFeaturedDashboard: 'Get Featured on the Karma Dashboard',
  putYourHand:
    "Put your hand, products, or promotions in the exact place our users come when they're ready to buy. We can create a variety of custom branded content that will drive warm traffic wherever you need it to go.",
  exactPlace: 'Put your brand in the exact place our users come when they’re ready to buy.',
  dedicatedInAppPlacement: 'Dedicated In-App Placement',
  dashboardFeaturedBanners: 'Dashboard Featured Banners',
  dashboardPopUpMessages: 'Dashboard Pop-Up Messages',
  customEmailsAndNewsLetters: 'Custom emails and newsletter placement to {{subscribers, number}}+ subscribers',
  customEmails: 'Custom Emails to {{subscribers, number}}+ Subscribers',
  getMoreEyes:
    'Get more eyes on your latest offer, coupon code, or product line with a dedicated email or newsletter placement to shoppers.',
  putYourBrand: "Put your brand in the exact place our users come when they're ready to buy.",
  newsletterInclusion: 'Newsletter Inclusion',
  dedicatedCustomEmails: '{{percent, number}}% Dedicated Custom Emails',
  bannerPlacementInEmails: 'Banner Placement in Notification Emails',
  pushNotificationsToShoppers: 'Push notifications to {{shoppers, number}}+ shoppers',
  pushNotificationsGiveTouchPoint:
    'Push notifications give your campaign another touch point and offer high open and click rates.',
  featureBrandClients: 'Featured Brand Clients',
  growingPerMonth: 'Growing +{{number, number}}k per month',
  members: 'Members',
  percent: '{{value, number}}%',
  kindOfReachYouExpect: 'What kind of reach can you expect?',
  ourAudience: 'Our Audience',
  tabIntoNewSource: 'Tap into a new source of qualified customers for your next campaign',
  tellUsAboutYourCompany:
    'Tell us a bit about your company’s goals and we’ll show you how together we can exceed them.',
  openAndTap: 'Open Safari and go to the product page you would like to save and tap the ‘Share’ button.',
  shareIllustration: 'Share illustration',
  tapMore: 'Tap the ‘More’ button on the right of the panel.',
  moreIllustration: 'More illustration',
  enableIllustration: 'Enable illustration',
  tapEdit: 'Tap the ‘Edit’ button at the top of the panel.',
  enableApp: 'Enable Karma and add tap the green ‘add’ button to add it to your Favourites and then tap ‘Done’.',
  goBackToTheProduct:
    'Go back to the product page, tap the ‘Share’ button again and then tap the ‘Karma’ button to save your product.',
  recommendedBy: 'Recommended by',
  ourMembersSavingMoney: "Our shoppers ❤️ saving money with Karma. Here's why.",
  ourMembersSavingMoney2: "Our shoppers <1/> saving money with Karma. Here's why.",
  addToBrowser: 'Add to {{browser}} - It’s Free',
  planPurchases: 'Plan your next purchases',
  karmaMakesItEasy: 'Karma makes it easy to organize your next purchases in one place.',
  buyAtRightTime: 'Buy at the right time',
  automaticallyAlert: 'Karma automatically alerts you when it’s the right time to buy.',
  cashOnVacation: 'Cash Back on your next vacation',
  karmaPartners: 'Karma partners with many travel and hotel sites.',
  headerRewards: 'Karma | Best Coupons and Cash Rewards',
  mission: 'Our Mission',
  empowerYou: 'Empower you to make the right choices at the right time when you shop online.',
  weAreSeriousAboutPrivacy: "We're serious about your privacy and security",
  weDoNotSellData: 'We don’t sell your data',
  karmaIsSerious: 'Karma is very serious about your data and we will never sell it to any third parties. Ever.',
  karmaIsSecure: 'Karma is secure',
  weUseBankSecurity:
    'We use bank-level security ({{bit, number}}-bit encryption) to make sure your information is safe and secure.',
  helpsSaveMore: 'Karma helps you save more!',
  alertMe: 'Alert Me',
  buyWithKarmaEarn: 'Buy with Karma - Earn ${{number, number}}',
  productSaved:
    'Congratulations! This product has been saved to your items list. You will be notified when the price drops.',
  willApplyTheBestCoupons: 'Karma will automatically apply the best coupons to your purchase!',
  downloadAndAutoApply: 'Download Karma & Auto Apply',
  whatIsKarma: 'What is Karma?',
  claimUpToRewards: 'Claim up to {{number, number}}% Cash rewards',
  youMightAlsoLike: 'You might also like',
  weAreSorry: 'We are sorry, but something went wrong and page cannot be displayed.',
  tryToReloadPage: 'Try to reload the page, please.',
  Color: 'Color',
  Size: 'Size',
  latestCoupons: "{{name}} | Karma's Latest Coupons & Cashback {{year, clearNumber}}",
  neverPayFullPrice: "Never Pay Full Price. Get Karma's {{name}} Coupons & Cashback",
  neverPayFullPriceForTag: 'Never Pay Full Price for {{name}}',
  saveMoneyWhenShoppingAt: 'Save Money When Shopping at {{name}}. Join Karma For Free',
  saveMoneyWhenShoppingFor: 'Save Money When Shopping for {{name}}. Join Karma For Free',
  tagByBrand: 'Karma | {{tag}} by {{brand}}',
  typeToSearch: 'Type to search',
  getUSDWhenJoinToday: 'Get ${{value, number}} When You Join Karma Today!',
  buyProduct: 'Buy Product',
  userWishList: 'Karma | {{name}} wish list',
  byWhom: 'by',
  copiedToClipboard: 'Copied to clipboard!',
  change: 'Change',
  send: 'Send',
  cause: 'Select cause:',
  aCause: 'Select a cause:',
  close: 'Close',
  selectThisCause: 'Select this cause',
  habitatForHumanity:
    '{{name}} is focused on long-term poverty alleviation through affordable social housing, their mission is to build a safe environment where families and communities can thrive',
  casaDescription:
    'The National CASA/GAL Association, supports and promotes court-appointed volunteer advocacy so every child who has experienced abuse or neglect can be safe, have a permanent home, and the opportunity to thrive',
  endHomelessnessDescription:
    'The National Alliance to {{name}} is a nonpartisan organization committed to preventing and ending homelessness in the United States',
  pathDescription: 'PATH is ending homelessness for individuals, families, and communities',
  feedingAmericaDescription: 'Feeding America is the nation’s largest domestic hunger-relief organization',
  mealsOnWheelsDescription:
    '{{name}} empowers local community programs to improve the health and quality of life of the seniors they serve so that no one is left hungry or isolated',
  actionAgainstHunger:
    '{{name}} is a global humanitarian organization that takes decisive action against the causes and effects of hunger',
  supportMedicalAdvancement: 'Support Medical Advancement',
  saveChildsHeartDescription:
    "Save A Child's Heart mends hearts regardless of race,  religion, gender, nationality or financial status",
  su2c: 'Stand Up To Cancer (SU2C) funds and develops the newest and most promising cancer treatments to help patients today',
  drWithoutBorders: '{{name}} is An independent, global movement providing medical aid where it’s needed most',
  activeMinds:
    '{{name}} is the nation’s premier nonprofit organization supporting mental health awareness and education for young adults',
  cleanAirTaskForceDesc:
    '{{name}} pushes the change in technologies and policies needed to get to a zero-emissions, high-energy planet at an affordable cost',
  wwfDesc:
    "{{name}}'s mission is to conserve nature and reduce the most pressing threats to the diversity of life on Earth",
  waterkeepsDesc:
    '{{name}} fights for clean water. Waterkeeper Alliance works to ensure every community worldwide has drinkable, fishable, swimable water',
  xprice:
    'Every single day XPrize works to create a better world where everyone has access to clean water, nutritious food, affordable housing, effective learning, top-tier medical care and non-polluting, abundant energy',
  globalActDesc: '{{name}} works to put an end to sexual and commercial exploitation',
  pcaa: '{{name}} works hard to realize our vision of a world where all children grow up happy, healthy, and prepared to succeed in supportive families and communities',
  endCAN:
    'EndCAN raises awareness of the health, mental health and public health impacts of abuse with a mission to end child abuse and neglect',
  futuresDesc:
    'FUTURES provides groundbreaking programs, policies, and campaigns that empower individuals and organizations working to end violence against women and children around the world',
  thornDesc: '{{name} builds technology to defend children from sexual abuse.',
  'Eradicate Homelessness': 'Eradicate Homelessness',
  'Help End Hunger': 'Help End Hunger',
  'Support Medical Advancement': 'Support Medical Advancement',
  'Combat Climate Change': 'Combat Climate Change',
  'Act To End Abuse': 'Act To End Abuse',
  itemsYouSaved: 'Items You Saved For Less',
  beta: 'BETA',
  alsoAvailableAt: 'Also available at',
  atName: 'at {{name}}',
  bestPrice: 'Best Price',
  passwordWasSuccessfullyReset: 'The password was successfully reset',
  karmaIsAlwaysWithYou: 'Karma is always with you when you shop',
  saveItemsToBuy: 'Save Items and we’ll tell you the best time to buy',
  weDoTheWork: 'We do the work to find you the best coupons',
  earnRealCashThatAdds: 'Earn real cash that adds up in your wallet',
  setUpStrongPassword: 'Set up a strong password',
  settingEmailAccount:
    'The last step to saving money with Karma? Sign up so we can notify you of important alerts on your Items, like price drops.',
  settingPasswordAccount:
    'The password must be formed of a minimum of {{number, number}} characters and it shouldn’t include your email credentials.',
  paidWith: 'Paid with',
  infoFirstNumber: '{{number, number}}{{unit}}+',
  infoFirstTitle: 'Members',
  infoSecondNumber: '{{number, number}}{{unit}}+',
  infoSecondTitle: 'Monthly Visits',
  infoThirdNumber: '{{number, number}}{{unit}}+',
  infoThirdTitle: 'Email List',
  infoFourthNumber: '{{value, number}}%',
  infoFourthTitle: 'Millenials',
  infoFifthNumber: '{{value, number}}%',
  infoFifthTitle: 'Female',
  infoSixthNumber: '{{value, number}}%',
  infoSixthTitle: 'US located',
  infoSeventhNumber: '{{number, number}}{{unit}}+',
  infoSeventhTitle: 'Opt-in mobile push notifications',
  infoEighthNumber: '{{number, number}}{{unit}}+',
  infoNinthPreNumber: '',
  infoNinthNumber: '${{number, number}}{{unit}}+',
  infoNinthTitle: 'Will be spent by users by end of {{year, clearNumber}}',
  countWaysToUse: '{{number, number}} Ways to use Karma',
  goBack: 'Go Back',
  pleaseChooseStrongerPassword: 'Please choose a stronger password',
  pleaseEnterValidEmailAddress: 'Please enter a valid email address',
  illSignUpLater: 'I’ll sign up later',
  joinOur1MEarningUsers: 'Join our 1M earning users',
  enterYourEmailAddress: 'Please enter your email address and we will send you a link to reset your password.',
  headerOnboardingIosExtension: 'Karma | Onboarding IOS Extension',
  weWillAutomaticallyApplyCouponsWhereverYouShop: 'We’ll automatically apply coupons wherever you shop',
  continue: 'Continue',
  changeLanguage: 'Change Language',
  selectedLanguage: 'Selected Language',
  headerMuteItem: 'Karma | Mute Item',
  itemHasBeenMuted: 'This item has been muted.',
  toUnmuteItem: 'To unmute this item:',
  openKarma: 'Open',
  headToMyItems: 'Go to your saved items',

  clickThreeButtonsInItem: 'Click the three buttons on the bottom right corner of the item',
  clickUnmute: 'Click on the item you want to unmute',
  changeNotification: 'Change notification settings under the item’s price',
  weveJustRaisedInFunding: 'We’ve just raised ${{value, number}}M in series A funding to help you shop smarter!',
  weveJustRaised: 'We’ve just raised ${{value, number}}M',
  landingReview1: 'Great App! I got a price drop alert and saved a lot of money!',
  landingReview2: 'Saved me ${{value, number}} on my first purchase. Very impressed!',
  landingReview3: 'It’s a beneficial app; love the notifications and rewards.',
  landingReview4: 'I have yet to experience a more seamless shopping experience!',
  landingReview5: 'I saved {{value, number}}%! I wouldn’t have known about the sale otherwise!',
  landingReview6: 'Easy to track the products you love... Highly recommend...!',
  landingReviewAuthor1: 'Justin Nguyen',
  landingReviewAuthor2: 'Amy Ellis',
  landingReviewAuthor3: 'Maude Aethelredd',
  landingReviewAuthor4: 'Patrick Slocum',
  landingReviewAuthor5: 'Michelle Findley',
  landingReviewAuthor6: 'Varsha Hulekal',
  auxiliaryDate: '{{date}}',
  resetMyPassword: 'Reset My Password',
  repeatPassword: 'Repeat Password',
  continueAsGuest: 'Continue as Guest',
  viewAt: 'View at {{- name}}',
  signUp: 'Sign up',
  youMayAlsoLike: 'You may also like',
  buyOnShop: 'Buy on',
  viewOn: 'View on {{- name}}',
  quickView: 'Quick View',
  newList: 'New List',
  undo: 'Undo',
  productDeleted: 'Product Deleted',
  linkCopiedToClipboard: 'link copied to clipboard',
  wishlists: 'Wishlists',
  headerPartnerships: 'Karma | Partnerships',
  letsJoinForces: 'Let’s join forces',
  bePartOfTheSmartShoppingRevolution:
    'Be a part of the smart shopping revolution. We’ll get your brand in front of over {{number, number}} million shoppers who are ready to check out.',
  seeKarmaInAction: 'See Karma in action',
  discoverHowKarma:
    'Discover how Karma’s AI and automation-based solutions enhance the entire shopping journey, driving targeted traffic to your offers.',
  stepUpYourSales: 'Step up your sales',
  averageROAS: 'Average<br/>ROAS',
  increaseInAOV: 'Increase<br/>in AOV',
  useKarmaToPlanTheirNextPurchase: 'Use Karma to plan<br/>their next purchase',
  meetOurShoppers: 'Meet our shoppers',
  meetOurShoppersDescription:
    'Leverage our performance-driven marketing solutions and make your mark on shoppers with high intent to buy. Our cross-platform placements enable you to reach users wherever they are.',
  audienceInfoFirstNumber: '{{number, number}}{{unit}}+',
  audienceInfoFirstTitle: 'Users',
  audienceInfoSecondNumber: '{{number, number}}{{unit}}+',
  audienceInfoSecondTitle: 'Monthly visits',
  audienceInfoThirdNumber: '{{number, number}}{{unit}}+',
  audienceInfoThirdTitle: 'Saved items',
  audienceInfoFourthNumber: '{{value, number}}%',
  audienceInfoFourthTitle: 'US based users',
  audienceInfoFifthNumber: '{{value, number}}%',
  audienceInfoFifthTitle: 'Gen Z & millennials',
  audienceInfoSixthNumber: '{{value, number}}%',
  audienceInfoSixthTitle: 'Female shoppers',
  ourUsersLoveUs: 'Our users love us!',
  partnershipsReview1:
    'A great extension! I’ve used it for years and it’s great to be able to save lots of products in one place - it makes online shopping so much less stressful!',
  partnershipsReviewAuthor1: 'Millie Robinson',
  partnershipsReview2:
    'Coming from a person who does a TON of online shopping, I can honestly say that Karma is a shoppers best friend for many reasons...',
  partnershipsReviewAuthor2: 'Sadie Mae',
  partnershipsReview3:
    'Best Shopping App in Play Store. So easy to use. I have all my saved items at my favorite stores in one app! 👍🏻',
  partnershipsReviewAuthor3: 'Kimberly Rogers',
  performanceBasis: 'Performance basis',
  fixedFee: 'Fixed fee',
  thanksForSubmitting: 'Thanks for submitting!',
  someoneFromOurPartnershipsTeamWillBeInTouchShortly: 'Someone from our partnerships team will be in touch shortly.',
  letsKickStartOurPartnership: 'Let’s kick start our partnership!',
  emailOrPhoneNumber: 'Email or phone number',
  retailerName: 'Retailer name',
  affiliateNetwork: 'Affiliate network',
  budgetStructure: 'Budget structure',
  budget: 'Budget',
  tellUsMore: 'Tell us more',
  pleaseFillInAllRequiredFields: 'Please fill in all required fields',
  partnerships: 'Partnerships',
  weCannotSaveThisItem: 'We cannot save this item <1/> as this store is not supported',
  theresCoupon: 'There’s a coupon!',
  yourItemIsOffWithCode: 'Your item is {{value, number}}% off with code {{code}} at {{- name}}.',
  muteAllNotification: 'Mute all notification',
  unMuteAllNotification: 'Unmute all notification',
  notificationSettings: 'Notification settings',
  deleteNotification: 'Delete notification',
  notificationDeleted: 'Notification deleted',
  itemMuted: 'Item muted',
  itemUnMuted: 'Item unmuted',
  priceDrop: 'Price drop',
  superDeal: '🔥 Super Deal',
  notSureWhenToBuy: 'Not sure when to buy? Create a free account and we’ll tell you when it’s deal time.',
  tcMayApply: 'T&C’s may apply',
  earnKarmaCash: 'Earn up to {{percent, number}}% Cash Back.',
  saveToKarma: 'Save item to Karma',
  getKarmaToTrackItem: 'Get Karma to track item',
  itemSaved: 'Item Saved!',
  youCanNowFindItem: 'You can now find your item on your Karma Dashboard.',
  getKarmaExtension: 'Get the Karma extension to <1/> track this must-have',
  notifyYou: 'We’ll notify you when it’s the best time to buy!',
  downloadTheExtension: 'Download the extension',
  outOfStock: 'Out Of Stock',
  invalidEmailError: 'Invalid email',
  collapse: 'Collapse',
  expand: 'Expand',
  lists: 'Lists',
  organizeYourItemsIntoWishListsWithJustAClick: 'Organize your items into wish lists with just a click.',
  newItem: 'New Item',
  helpCenter: 'Help Center',
  priceHighToLow: 'Price High to Low',
  priceLowToHigh: 'Price Low to High',
  sale: 'Sale',
  filterBy: 'Filter by:',
  karmaExclusive: 'K Exclusive',
  noItemsFound: 'No items found',
  select: 'Select',
  likeSneakersOrBlackFriday: 'Like ‘Sneakers’ or ‘Black Friday’',
  updateList: 'Update List',
  firstName: 'First Name',
  lastName: 'Last Name',
  enterFirstName: 'Enter first name',
  enterLastName: 'Enter last name',
  recentSearches: 'Recent searches',
  addYourFavoriteStores: 'Add your favorite stores',
  toAccessTheirLatestCoupons: 'to access their latest coupons',
  logosProvidedByClearbit: 'Logos provided by Clearbit',
  dateOfBirth: 'Date of birth',
  weHaveEmailedYouALinkToResetYourPassword: "We've emailed you a link to reset your password.",
  didNotGetIt: "Didn't get it?",
  profile: 'Profile',
  promotionsAndActivity: 'Promotions & activity',
  couponsForFavoriteStores: 'Coupons for favorite stores',
  accountActivity: 'Account activity',
  powerShopper: 'Power shopper? 💪',
  enterLinkToAnyItemPage: 'Enter a link to any item page',
  saveStuffWithZeroFuss: '<0>Get the browser extension</0> and save stuff with zero fuss.',
  viewMore: 'View more',
  tooHotToMiss: 'Too Hot To Miss',

  // WebsiteLandingKarmaOld
  joinShoppers: 'Join over {{number, number}} million shoppers',
  waysToUse: 'Ways to use Karma',
  youCanUseKarma:
    'You can use Karma in many ways like making sure you get the best price at the right time along with planning your next purchases. Here are a few examples that we recommend:',
  livesInBrowser: 'Karma lives in your browser',
  browserExtension: 'Karma’s browser extension meets you wherever you shop across the web.',
  helpsYouPlan: 'Helps you plan your next purchases',
  notReadyToBuyJust:
    'Not ready to buy just yet? Save it for later with Karma’s browser extension and shop more mindfully. You can keep an eye on all your saved items in one place. ',
  automaticallyFindsCouponCodes: 'Automatically finds coupon codes',
  findsAndAppliesCodes:
    'Karma automatically finds and applies the best coupon for you, so you know you get the best value every time.',
  soYouCanBuyAtTheRightTime: 'So you can buy at the right time',
  usesCleverTechnologies:
    "Karma uses clever technology to track if the price drops, or when it's back in stock, so you can buy at the right time. ",
  notOnlySave:
    'Not only does Karma save you money - it also makes you money! No points. No gimmicks. You earn real cash every time you shop.',
  makeImpact: 'Make an impact!',
  donate:
    'Shop as you normally would and watch how Karma keeps giving back. For every purchase over ${{over, number}}, we donate ${{dollars, number}} to a cause of your choice.',
  accessToOffers: 'Access to exclusive offers',
  accessItems:
    'Access your saved items in one place, discover exclusive offers and see what’s trending around the world on Karma.',
  hereIsHowItWorks: 'Here’s how it works',
  learnMoreAboutGives: 'Learn more about Karma Gives',
  alwaysKnowWhenPricesDrop: 'Always know when prices drop',
  getNotifiedWhenBackInStock: 'Get notified when it’s back in stock',
  findsYouBestCoupons: 'Finds you the best coupons',
  getKarmaCashWhenYouShop: 'Get Cash Back when you shop',
  easilySaveAllThings: 'Easily save on all your favorite things on {{value, number}}K+ stores',
  karmaProvidesGreatTechnology:
    'Karma provides you with great technology and flexibility to shop smarter, helping you avoid those unnecessary impulse buys, all while saving you time and money.',

  followOnLinkedin: 'Follow Us on LinkedIn',
  lookingForInfluencer: 'Looking for advertising partnerships?',
  skipForNow: 'Skip for now',
  noNotificationsYet: "You're all caught up",
  noNotificationsYet2: "As soon as there's a price drop or restock update, you'll find it here.",
  earnKarmaCashShort: 'Up to {{percent, number}}% Cash Back',
  balance: 'Balance',
  earned: 'Earned',
  areYouSureYouWantToDisconnectFromPaypal: 'Are you sure you want to disconnect from Paypal?',
  youHaveToReconnectToWithdraw: 'You’ll have to reconnect to withdraw your Cash Back.',
  nevermind: 'Nevermind',
  yesDisconnect: 'Yes, disconnect',
  stuffWorthSavingGoesHere: 'Stuff worth saving goes here 👇',
  seeHowToSave: 'See how to save',
  itsAGhostTown: `It's a ghost town`,
  addStuffYouFindToThisListToKeepItOrganized: 'Add stuff you find to this list to keep it organized.',
  checkItOffAsYouBuy: 'Check it off as you buy',
  markItemsYouveMadeYourOwnItFulfillsSoGood: `Mark items you’ve made your own. It fulfills so good!`,
  playFavesWithYourItems: 'Play faves with your items',
  starTheThingsYouNeedInYourLifeForQuickAccess: 'Star the things you need in your life for quick access.',
  yourSearchCameUpEmpty: 'Your search came up empty',
  trySearchingForSomethingElse: 'Try searching for something else.',
  freshOutCoupons: 'Fresh out of coupons',
  weHitYouUp: "We'll hit you up when we find a promo code for this store.",
  firstAddToList: 'First, add to list',
  youNeedToSaveItemsBeforeYouCanShareYourList: 'You need to save items before you can share your list.',
  enterYourPassword: 'Enter your password',
  passwordValidationNote:
    'Must be at least 8 characters, including an uppercase letter, a lowercase letter, and a number.',
  karmaIsAnApp: 'Karma is an app and extension that helps you save time and money while shopping online.',
  addOneItemToList: 'Add 1 item to list',
  addNumberItemsToList: 'Add {{value}} items to list',
  markNumberItemsAsFullfilled: 'You’re about to mark {{value}} items as fulfilled',
  youReAboutToMuteNumberItems: 'You’re about to mute notifications for {{value}} items',
  sureYouWantToDeleteTheseNumberItems: 'Sure you want to delete these {{value}} items?',
  sureYouWantToDeleteThisList: 'Sure you want to delete this list?',
  missingYouAlready: 'Missing you already!',
  other: 'Other',
  otherDescription: 'Your feedback <1>helps us improve,</1> and who knows<2/>—we might just fix your issue ASAP',
  howElseCanWeImproveKarma: 'How else can we improve Karma?',
  meetYouAtIn: 'Meet you at {{retailer}} in 3 seconds...',
  gotStuck: 'Got stuck? Click <1>here</1> to get moving.',
  weGotStuckOnOurWay: 'We got stuck on our way to {{retailer}}!',
  tryAgain: 'Try again',
  preparingYourKarmaCash: 'Prepping your Cash Back.',
  savingMoneyIsHotLetsGetOnThat: "Saving money is hot. Let's get on that ✌️",
  thisFieldIsRequired: 'This field is required',
  takeControlOfYourInbox: 'Take control of your inbox',
  whyUnsubscribeFromAllOurMoneySavingEmails:
    'Why unsubscribe from all our money-saving emails when you can turn off just those that aren’t relevant?',
  storePromotionsAndOtherMarketingEmails: 'Store promotions and other marketing emails',
  itemUpdatesUnsubscribe: 'Item updates (price drops, restocks, and more)',
  accountActivityAndImportantInformation: 'Account activity and important information',
  stillWannaUnsubscribe: 'Still wanna <1>unsubscribe from all Karma emails</1>?',
  alrightBut: 'Alright, but you’re in for some major fomo!',
  updatePreferences: 'Update preferences',
  connectToPayPalToCashOut: 'Connect a PayPal account to cash out your rewards',
  weAreBusySelfImproving: 'We’re busy self-improving',
  sorryForInconvenience: "Sorry for the inconvenience - we promise it'll be worth it.",
  search: 'Search',
  dropSomeShoppingInspo: 'Drop some shopping inspo on your fam.',
  orCopyTheLinkBelowAndSend: 'Or, copy the link below and send it to them old-school style.',
  joinTheTeam: 'Join the team',
  info: 'Info',
  gotIt: 'Got it',
  wereHereToMakeItYours: 'We’re here to <1>#make_it_yours</1>',
  lookAtYouLittleScroller: 'Look at you, you little scroller. Kudos for getting this far.',
  nowLetsTalkAboutPrivacy: 'Now let’s talk privacy 🤫',
  weUseBankLevelSecurity: 'We use bank-level security',
  yourInformationIsSecured: 'Your information is secured using the latest 256-bit encryption for complete protection.',
  weDontSellYourData: 'We don’t sell your data',
  weAreVerySeriousAboutPrivacy:
    'We’re very serious about privacy and will never sell your data to any third parties. Ever.',
  soFarWeSavedYou: 'So far, we’ve saved you',
  happyShoppers: '👉 {{count, number}}M+ happy shoppers',
  starReviews: '👉 {{count, number}}K+ 4.7 star reviews',
  storesWorldwide: '👉 {{count, number}}K+ stores worldwide',
  wellTrackAndScanForCoupons:
    'We’ll track and scan for coupons so you don’t have to. <br/> (ok we won’t, but our AI will)',
  lolWereAVerbNow: '(lol we’re a verb now)',
  letsPlay: 'Let’s play',
  noFomoHere: 'No fomo here. We’ll give you a buzz when your ‘wishes’ drop in price or come back in stock.',
  never: 'Never',
  missOut: 'miss out',
  cashIsBack: '<1>Cash</1> is back',
  cashIsBackColoredRight: 'Cash is <1>back</1>',
  withKarmaYourCash: 'With Karma, your cash comes back to you like some sort of voodoo, magic money.',
  getIt: 'Get it',
  wantIt: 'Want it',
  wereGoingShopping: 'We’re going shopping',
  knowHowToShopBetter: 'Know how to <1>shop better</1> than everyone else',
  addKarmaToYourDesktop: 'Add Karma to your desktop so you can shop<br/>during work hours.',
  yesIDoThat: 'Yes, I do that',
  iNeedThisInMyLife: 'I need this in my life',
  payLess: 'Pay less',
  money: 'money',
  theMotherOfAllWishLists: 'The mother of all <1>wish lists<1/>',
  nowLetsTalPrivacy: 'Now let’s talk <1>privacy<1/>',
  withKarmaYouCanBuy: 'With Karma you can buy<br />whatever you want and keep<br />the bank lady happy.',
  youReATen:
    'You’re a 10 and you pay with Karma? Shop online and get the lowest possible price every 👏 single 👏 time.',
  karmaYourFavoriteBrands: '<1>Karma</1> your favorite brands',
  buyWhateverYouWant: 'Buy whatever you want and keep the bank lady happy.',
  onlineShoppingButBetter: 'Online shopping but <1>better</1>',
  downloadOurApp: 'Download our app and take <1>Karma to-go</1>',
  getTheApp: 'Get the app',
  karmaGetsYouTheLowestPossiblePrice: 'Karma gets you the lowest possible price every 👏 single 👏 time.',
  weHustleForCoupons: 'We hustle for <1>coupons</1>',
  wellTrackAndScanForCouponsMobile: 'We’ll track and scan for coupons so you don’t have to.',
  wellApplyCodesThatSaveYouMoney: 'We’ll apply codes that save you $$$.',
  getBuzzedWhenYourWishes: 'Get buzzed 🐝 when your ‘wishes’ drop in price or come back in stock.',
  yourCashWillComeBackToYou: 'Your cash will come back to you like some sort of voodoo, magic money. ',
  karmaYourFavoriteBrandsMobile: '<1>Karma</1> your favorite brands',
  lookAtYouLittleScrollerMobile: 'Look at you, you little scroller.',
  wereAVerbNowLol: '(we’re a verb now lol)',
  total: 'Total',
  keepAnEyeOutForTheStatusUpdatesWeWillSendToEmail: 'Keep an eye out for the status updates we’ll send to {{email}}.',
  psaDidYouKnow: 'PSA: Did you know that you can',
  addWishItemsFromAnyBrand: 'Add ‘wish’ items from any brand and hang out until we say it’s time to get them.',
  capturePurchaseReadyShoppers: 'Capture purchase-ready shoppers by showcasing your hottest coupons.',
  gainFullFunnelInsights: 'Gain full-funnel insights into buyer intent with every item saved.',
  boostCartEngagement: 'Boost cart engagement with our real-time item updates.',
  promoteLongTermGrowth: 'Promote long-term growth through tailored campaigns within the Karma ecosystem.',
  reachNewAudiences: 'Reach new audiences through diverse campaigns tailored to your brand',
  influencerCollaborations: 'Influencer collaborations',
  teamUpWithTopInfluences: 'Team up with top influencers that best match your brand’s identity.',
  socialPosts: 'Social posts',
  giveANewFollowing: 'Gain a new following from bespoke, content-rich campaigns.',
  brandFocusedNewsletters: 'Brand-focused newsletters',
  letYourOffersShine: 'Let your offers shine in highly anticipated curated emails.',
  driveTrafficWhenYouNeedIt: 'Drive traffic where you need it to go with our shoppable homepage placements',
  dashboardBanners: 'Dashboard banners',
  flauntYourLatestOfferings: 'Flaunt your latest offerings with eye-catching visuals.',
  dailyFeatured: 'Daily featured',
  highlightDeals: 'Highlight deals where it matters most.',
  dedicatedPopUps: 'Dedicated pop-ups',
  activelyServeYourPromos: 'Actively serve your promos so they can’t be missed.',
  createAnotherTouchpointForYourBrand: 'Create another touchpoint for your brand',
  increaseEngagement: 'Increase engagement and conversion rates through targeted push notifications on mobile and web.',
  karmaIsOnlineShoppingButBetter: 'Karma is online shopping, but better.',
  transactionsNumber: '👉 {{count, number}}M+ transactions',
  partnershipsReview4: 'This is fantastic for making your wish list and saving money!',
  partnershipsReviewAuthor4: 'Emily Smith',
  partnershipsReview5:
    'It’s literally the best extension I’ve ever downloaded. It’s the best for saving money and getting money at the same time!',
  partnershipsReviewAuthor5: 'Selena Roblox',
  noNeedToSlideIntoOurDMs:
    'No need to slide into our DM’s (you could though 😏). Our team is here for whatever you need.',
  supportIssues: 'Support issues',
  adsAndPartnerships: 'Ads & Partnerships',
  jobOpportunities: 'Job opportunities',
  publicRelations: 'Public relations',
  letsChat: 'Let’s chat',
  earnings: 'Earnings',
  allTime: 'All time',
  ordersMayTakeHoursToAppear: 'Orders may take up to {{value, number}} hours to appear.',
  youHaventReceivedAnyPayoutsYet: 'You haven’t received any payouts yet ',
  alerts: 'Alerts',
  featuresReview1:
    'I added a pair of sneakers to my wishlist and literally the next day got a ping that it was 50% off. How did I even buy anything before you guys?',
  featuresReviewAuthor1: 'Sandra C.Martinez, App store reviewer',
  featuresReview2:
    'This is seriously the best smart shopping app and I know of a few others. I actually feel like I’m cheating the system a little bit because I’m saving actual money! I always used to pay full and feel like such a sucker',
  featuresReviewAuthor2: 'Gertie D. Ackerman, App store reviewer',
  featuresReview3:
    'I was shopping for a new laptop that was already 25% off. When I hit ‘pay with Karma’, I noticed that the total was even less. This happens every time I pay with the app',
  featuresReviewAuthor3: 'Irene J. Cox, App store reviewer',
  downloadNow: 'Download now',
  wannaBeDeskBuddies: 'Wanna be desk buddies?',
  seeOpenPositions: 'See open positions',
  weLiveAndSwearBy: 'We live and swear by...',
  goodKarma: 'Good Karma',
  weBelieveThatGoodVibes: 'We believe that ~good vibes~ are a lifestyle and we’re sticking to it.',
  beingTrue: 'Being true',
  theresNoUSvsU: 'There’s no US vs U. Our tables are always round and we’re saving you a seat.',
  passion: 'Passion',
  weHaveThatFireYouKnow: 'We have that fire, u know? We operate on drive, persistence, and love for what we do.',
  entrepreneurship: 'Entrepreneurship',
  weWantItWeGetIt: 'We want it - we get it. We don’t have any time to waste on endless Zooms. We go for what we want.',
  mutuality: 'Mutuality',
  wereMadeUpOfAwesomePeople:
    'We’re made up of awesome people who understand that teamwork is not enough. We actually care for each other.',
  buildCustomerLoyalty: 'Build customer loyalty with instant cash back',
  itemSaving: 'Item saving',
  itemUpdates: 'Item updates',
  backInStockAlerts: 'Back in stock',
  lowInStockAlerts: 'Low in stock',
  storePromotions: 'Store promotions',
  exclusive: 'Exclusive',
  couponCopied: 'Coupon copied',
  completedDesc:
    'The store has confirmed your order. Any Cash Back earned can be withdrawn {{days, number}} days from date of purchase and only after you’ve reached the {{currency}}{{amount, number}} minimum.',
  pendingDesc:
    'The store has received your order. It may show as pending for up to {{days, number}} days, depending on the store’s return policy.',
  cancelledDesc: 'The store has informed us that your order was either canceled or refunded in full.',
  downloadNowItsFree: 'Download now, it’s free',
  weLiveToMakeOurShoppersHappy: 'We live to make our shoppers happy',
  moneySavedForYou: 'Money saved for you',
  moneySavedForUsers: 'Money saved for users',
  happyShoppers2: 'Happy shoppers',
  starReviews2: '{{value, number}} star reviews',
  storesWorldwide2: 'Stores worldwide',
  whyYouWill: 'Why you’ll',
  it: 'it',
  multiBrandWishLists:
    'Multi-brand wish lists? Legit chills. Spot something you love from any brand, add it to your Karma list, and hang out until we say it’s time to  get them.',
  addKarmaToYourMobile: 'Download<br />our app<br />and take<br />Karma to-go',
  appStoreReview1:
    'I added an eyeshadow palette to my list and the next day got a notification that it was 50% off. Thank you!!',
  appStoreReview2: 'The fact that the lowest price is always right in my pocket is so dangerous. But also I love it',
  appStoreReview3: 'Just scored the lowest price on new headphones while waiting for the bus. It’s just too easy',
  appStoreReviewBy: 'App store review by: {{name}}',
  yourInfoSafeWithUs: 'Your info is safe with us',
  whyGiveOutYourCCDeets: 'Why give out your CC deets when you can keep it in one place?',
  partyForOne: 'Party for 1',
  wellNeverSellYourDataToAnyThirdParties:
    'We’ll never sell your data to any third parties, period. With bank-level security, your data is safe from prying eyes.',
  buyWithoutATrace: 'Buy without a trace',
  weWontLetAnyoneTrackYourShoppingHabits: 'We won’t let anyone track your shopping habits. There’s no judgment here.',
  spotSomethingYouLoveFromAnyBrand:
    'Spot something you love from any brand, add it to your Karma list, and hang out until we say it’s time to get them.',
  needIt: 'Need it',
  appStoreReviewer: 'App Store reviewer',
  appStoreReview4:
    'I rely on this app so much to keep track of all my "want" items in one place to get the at the best price possible.',
  appStoreReview5: 'This app has helped me save so much money.',
  wishlist: 'Wishlist',
  downloadWithKarmaAndSaveMajorCash: 'Download Karma<br/>and save major $$$',
  getTheLowestPriceAtAllYourFavoriteBrands: 'Get the lowest prices at all your favorite brands.',
  getTheAppForFree: 'Get the app for free',
  addKarmaSpaced: 'Add Karma,<br />to your desktop<br />so you can shop<br />during work hours.',
  spotSomethingYouLoveFromAnywhere:
    'Spot something you love from anywhere, add it to your Karma list, and hang out until we say it’s go time.',
  getCouponsCashbackWithPeriod: 'Get coupons, cash back, and price drop alerts.<br />Always pay the lowest price.',
  getCouponsCashbackWithAnd: 'Get coupons, cash back, price drop alerts<br />and always pay the lowest price.',
  clickTheLoginLinkFromYourPhone: 'Click the login link from your phone to access the Karma app.',
  getItOn: 'Get it on',
  downloadOnThe: 'Download on the',
  likeShoppingFromYourComputer: 'Like shopping from your computer?',
  getTheKarmaExtensionToShopEvenBetter: 'Get the Karma extension to shop even better.',
  headerMobileLogin: 'Karma | Install',
  noFomoHereMobile: 'No fomo here.\nWe’ll give you a buzz when\nyour ‘wishes’ drop in price\nor come back in stock.',
  withKarmaYourCashMobile: 'With Karma, your cash\ncomes back to you\nlike some sort of voodoo,\nmagic money.',
  spotSomethigYouLoveMobile:
    'Spot something you love\nfrom anywhere, add it to your\nKarma list, and hang out until\nwe say it’s go time.',
  wellTrackAndScanForCouponsMobile2:
    'We’ll track and scan\nfor coupons so you don’t have to.\n(ok we won’t, but our AI will)',
  weHustle: 'We hustle',
  forCoupons: 'for <1>coupons</1>',
  theMotherOfAll: 'The mother of all',
  wishlists2: 'wish lists',

  // NEW PHRASES
  whatItsLikeWorkingAtKarma2: 'What’s it like working at Karma?',
  makeItYours: 'Make it yours',
  continueWith: 'Continue with {{provider}}',
  onItsWay: 'On its way...',
  weVeEmailedInstructionsForResettingYourPassword:
    'We’ve emailed instructions for resetting your password to {{email}}',
  wrongEmailTryAgain: 'Wrong email? Try again',
  goToEmail: 'Go to email',
  heyYouLetsJumpBackIntoSaving: 'Hey you! Let’s jump back into saving',
  firstConfirmItsYou: 'First, confirm it’s you',
  letsDoThis: 'Let’s do this',
  signUpAndGet: 'Sign up and get',
  moneyOnUs: '{{currency}}{{value, number}} on us',
  usersHeroTitle: 'Your\nbank account’s gonna love this.',
  tellMeMore: 'Tell me more',
  createNewPassword: 'Create new password',
  joinKarma: 'Join Karma',
  saveItemsFromStores: 'Save items from your favorite stores with a single click',
  easilySaveAndKeep:
    'Easily save and keep track of everything you want to buy. The best\npart? You’ll get notified the second any of your saved items\ngo on sale, or come back in stock.',
  addTheFreeKarma:
    "Add the free Karma button to your browser so you can\neasily keep track of everything you want to buy. The best\npart? You'll get notified the second any of your saved items\ngo on sale, drop in price, or come back in stock.",
  getButtonAndGetEverything: 'Get the free Karma button and\nget everything you want on sale',
  getKarmaItIsFree: "Get Karma - It's Free!",
  onYourPhone: 'On your phone? Save items on the go with our free app',
  hereHowTheButtonWorks: "Here's how the Karma\nbutton works",
  ifThisWontHelp: "If this won't help, ",
  contactOurSupportCenter: 'contact our support center.',
  wellKeepAnEyeOnIt: 'We’ll keep an eye on it & will let u know ASAP if the price drops',
  seeYourSavedItems: 'See your saved items',
  dontSellMyPersonalInformation: 'Don’t sell my personal information',
  logInAndSaveItemToKarma: 'Login & Save item to Karma',
  postCode: 'Postcode',
  blogPromotions: 'Blog promotions',
  goToStore: 'Go to store',
  visitStorePage: 'Visit store page',
  favStoresUpdated: 'Your favorite stores were successfully updated.',
  availableCoupons_plural: '{{count}} available coupons',
  availableCoupons: '{{count}} available coupon',
  findAndComparedTheBestDeals: 'Finds and compares the best deals',
  karmaHelpsYouShopSmarter: 'Karma helps you shop smarter by finding the best benefits and rewards at checkout',
  expiring: 'Expiring',
  today: 'Today',
  tomorrow: 'Tomorrow',
  days: '{{count, number}} DAY',
  weeks: '{{count, number}} WEEK',
  months: '{{count, number}} MONTH',
  daysPlural: '{{count, number}} DAYS',
  weeksPlural: '{{count, number}} WEEKS',
  monthsPlural: '{{count, number}} MONTHS',
  tellUsWhyYouUninstalledTheExtension: 'Tell us why you uninstalled the extension',
  tooManyPopUpsWhileIShop: 'Too many pop-ups while I shop',
  couponsDontWork: 'Coupons don’t work',
  dataPrivacyConcerns: 'Privacy concerns',
  dataPrivacyConcernsTitle: 'Your privacy matters',
  dataPrivacyConcernsDescripReason:
    'Online privacy is serious business.<2/>We’re GDPR & CCPA compliant, and you can read </2>our <1><3>Privacy Policy</3></1> if you want all the details!',

  noRelevantDealsInMyFavedStores: 'No relevant deals in my faved stores',
  noRelevantDealsInMyFavedStoresDescription:
    'Karma <1>tracks price drops</1><2/> and <1>restocks</1>, so when a deal pops up, <1>you’ll<2/> know first.</1><2/> Stick around, and we’ll keep an eye out for<2/> savings!',
  theKbuttonWasInMyWay: 'The ‘K button’ was in my way',
  theKbuttonWasInMyWayDescription: 'No need to kick us out completely.<2/> Want to try adjusting it? Check out how',
  tooManyPopUps: 'Too many pop ups',
  tooManyPopUpsTitle: 'Timing is everything.',
  tooManyPopUpsDescription:
    'You can actually tweak how often Karma helps in<2/> settings, so it only <1>appears when you want it to.</1><2/> Give that a try?',
  causedProblemsWithMyBrowser: 'Caused problems with my browser',
  tellUsMoreOptional: 'Tell us more (optional):',
  shareYourThoughtsWithUs: 'Share your thoughts with us',
  myFavoriteStoresAreNotSupported: 'My favorite stores are not supported',
  notReadyToLetGoYet: 'Not ready to let go yet? Reinstall Karma with just one click',
  chatWithUsAndGet: 'Chat with us & get<br />${{count}} Amazon Gift Card',
  scheduleAMeetingAndEarnGiftCard:
    'Schedule a {{minutes}}-minute interview and earn a<br />${{count}} Amazon gift card.',
  scheduleAnInterview: 'Schedule an interview',
  compareProductsBeforeYouBuy: 'Compare products before you buy',
  youSearchedFor: 'You searched for',
  yourSavedItems: 'Your saved items',
  moreForYou: 'More for you',
  headerGlobalSearch: 'Karma | {{query}}',
  noResultsFoundFor: 'No results found for',
  pleaseReviewYourSpellingOrTryDifferentKeyword: 'Please review your spelling or try different keyword',
  heyThere: 'Hey, {{name}}',
  myAccount: 'My account',
  accountSettings: 'Account settings',
  trendingNow: 'Trending now',
  helpUsImproveKarma: 'Help us improve Karma',
  yourFavoriteStores: 'Your favorite stores',
  chooseYourFavoriteStores: 'Choose your favorite stores',
  viewStoreInfo: 'View store info',
  addStore: 'Add store',
  findMoreStores: 'Find more stores',
  whatAreYouShoppingFor: 'What are you shopping for?',
  searchForAnyItemBrandOrStore: 'Search for any item, brand or store',
  savedFromStore: 'Saved from store',
  manageFavoriteStores: 'Manage favorite stores',
  hasNoActiveCoupons: '{{retailer}} has no active coupons',
  checkOutOtherStores: 'Check out other stores for more deals',
  youCanStillEarn: 'You can still earn {{number}}% cashback with Karma!',
  retailerCoupons: '{{retailer}} coupons',
  nothingSavedYet: 'Nothing saved yet?',
  useOurBrowserExtension:
    'Use our browser extension on your {{retailerName}} visit to quickly add items to your favorites. Your shopping journey starts here!',
  letsMakeItPersonal: 'Let’s make it personal',
  selectAndTrack: 'Select your favorite stores and track coupons and deals',
  chooseYourFaves: 'Choose your faves',
  code: 'Code',
  itemFound: '{{count, number}} item found',
  itemFound_plural: '{{count, number}} items found',
  storeFound: '{{count, number}} store found',
  storeFound_plural: '{{count, number}} stores found',
  itemsTitle: 'Items',
  storeInfo: 'Store info',
  preOwned: 'Pre-owned',
  refurbished: 'Refurbished',
  favorited: 'Favorited',
  allPromotionsOrOffers:
    "All promotions or offers by any of our partners are subject to the applicable partner's terms and conditions, which may be changed by the partner at its discretion. We may receive a commission for purchases made through our links or using our coupons. Eligibility for a welcome bonus is subject to section 5 of Karma’s Terms & Conditions.",
  shippingInfo: 'Shipping info.',
  freeShipping: 'Free shipping',
  overMinAmount: 'over {{currency}}{{value, number(minimumFractionDigits: 2)}}',
  delivers: 'Delivers',
  deliveryDays: '{{value, number}} days',
  freeReturns: 'Free returns',
  upToDays: 'up to {{value, number}} days',
  deliveryInfo: 'Delivery info.',
  returnsInfo: 'Returns info.',
  notAvailable: 'Not available',
  minOrderMayApply: 'Min. order may apply',
  hottestDeals: 'Hottest deals',
  discoverCouponsAndExclusiveOffers: 'Discover coupons and exclusive offers',
  moreFromStore: 'More from {{store}}',
  seeWhatsTrendingNow: 'See what’s trending now',
  automaticallyApplyCoupons:
    'Automatically apply coupons at checkout, save what you love and earn cashback — all with the Karma extension.',
  deleteMyAccount: 'Delete my account',
  areYouSureDeleteAccount: 'Are you sure you want to delete your account?',
  deletingYourAccountWill:
    'Deleting your account will permanently remove all of your information, your saved items and your earnings from our database, and this action cannot be undone.',
  cancel: 'Cancel',
  accountDeletedSuccessfully: 'Account deleted successfully',
  shopOnTheGo: 'Shop on-the-go with Karma app',
  moveFromDevice: 'With Karma, effortlessly move from one device to another as you shop.',
  fewMomentsWeAreStillWorkingOnSavingItemsToThisList:
    'Few moments, we’re still working on saving items to this list... ',
  notificationDate: '{{date, shortFromNowDate}} ago',
  enableKarmaOn: 'Enable Karma on Safari',
  karmaNeedsToBeActivated: 'Oops! Karma needs to be activated',
  toAccessOurCouponScanner: 'to access our coupon scanner',
  dontSeeReview: 'I don’t see a “Review” button',
  iosOnboardingFlowYouNeedToUseSafari: 'You need to be in Safari to use<1></1>the Karma extension',
  iosOnboardingFlowCopyTheLink: 'Copy the link below and paste it in<1></1>Safari to continue.',
  iosOnboardingCopyLink: 'Copy link',
  iosOnboardingLinkCopied: 'Link copied',
  tapExtensionThenSelect: 'extension, then <1>select both middle options</1>',
  tap: 'Tap',
  activate: 'Activate',
  grantAccess: 'Grant access',
  continueShopping: 'Continue shopping',
  sweOnboardingStep1_1_2: 'in your search bar',
  sweOnboardingStep1_2: 'Select <1>“Manage Extensions”<1/>',
  sweOnboardingStep1_3: 'Toggle on <1>“Karma”</1>',
  sweOnboardingStep2_2_old:
    'Tap the Karma extension <1></1>, and select <3>“Always Allow...”</3>, then <5>“Always Allow on Every Website”</5>',
  sweOnboardingStep2_3_old: 'Select “Always allow”',
  sweOnboardingStep2_4_old_1: 'Select “Always allow”',
  sweOnboardingStep2_4_old_2: '“On every Site”',

  sweOnboardingStep2_5_old_1: 'Go back to the',
  sweOnboardingStep2_5_old_2: 'Karma app',
  sweOnboardingStep2_1: 'Tap <1>“Review”</1> in the top right corner, then <3>select both middle options</3>',
  shopSmarter: 'Shop better with\nthe power of AI',
  joinOurUsers: 'Join our {{number, number}} million users\nwho are shopping\nbetter from all their\ndevices',
  browseAndBuy:
    'Browse and buy from our desktop extension or\nuse the Karma app to ensure you’re always\ngetting the most out of your purchase.',
  joinCard1: '<0>$5 cash</0><1>at sign-up</1>',
  joinCard2: '<0>15K</0><1>5 star reviews</1>',
  joinCard3: '<0>13M+</0><1>coupons applied</1>',
  joinCard4: '<0>80 million</0><1>items saved</1>',
  joinCard5: '<0>$482</0><1>yearly avg savings</1>',
  joinCard6: '<0>$126</0><1>avg Cash Back earnings</1>',
  joinCard7: '<0>{{value}}M+</0><1>shoppers</1>',
  joinCard8: '<0>$7.50</0><1>avg order savings</1>',
  whatMakesKarmaGood: 'What makes Karma\nso good?',
  karmaGoodTitle1: 'Karma let’s you shop\nbetter from anywhere',
  karmaGoodDescription1:
    'Karma’s browser extension meets you\nwherever you shop. Shop directly in the Karma\napp or share the items you want to Karma.',
  karmaGoodTitle2: 'Helps you plan your\nnext purchases',
  karmaGoodDescription2:
    'Not ready to buy just yet? Save it for later in the\nKarma app or share it to Karma and shop more\nmindfully. You can keep an eye on all your\nsaved items in one place.',
  karmaGoodTitle4: 'So you can buy at the\nright time',
  karmaGoodDescription4:
    "Karma uses clever technology to track if the\nprice drops, or when it's back in stock, so you\ncan buy at the right time.",
  karmaGoodTitle5: 'Automatically finds you\n coupons at checkout',
  karmaGoodDescription5:
    'Karma automatically finds and applies the best\n coupons for you while you shop on Safari, so\n you know you get the best price every time.',
  onlyOnMobile: 'Only on the mobile app',
  empowerTouToMake: 'Empower you to\nmake the right\nchoices at the right\ntime when you shop\nonline.',
  dontTakeOurWord: 'Don’t take our word for it',
  totalSavings: 'Total savings',
  joinOurUsersDesktop: 'Join our {{number, number}} million users who are\nshopping better from all their devices',
  andAutomaticallyFindsYouCouponsAtCheckout: 'And automatically finds you coupons at checkout',
  clickAlwaysAllowOnEveryWebsite: 'Click <2>“Always Allow on Every Website“</2> so we can work on all your fave sites',
  weNeedYourPermissionToAutomaticallyShowYouTheBestDeals:
    'We need your permission to automatically show you the best deals on all your favorite shopping websites.',
  yourPrivacyAndSecurityIsImportantToUs: 'Your privacy and security are important to us - it’s in our',
  whileKarmaWillStillWork: 'While Karma will still work, it’ll require more effort on your part to find deals.',
  unfortunatelyWithoutTheAlwaysAllowPermission:
    'Unfortunately, without the “Always Allow on Every Website” permission you’ll have to manually click Karma whenever you shop',
  noThanksSignUpForAnAccount: 'No thanks, Sign up for an account',
  logInWithEmail: 'Log in with email',
  signUpWithEmail: 'Sign up with email',
  iAgreeToTermsOfUseAndPrivacyPolicy: 'I agree to <1>Terms of Use</1> and <3>Privacy Policy</3>',
  joinOurEnergeticTeam: 'Join Our Energetic Team',
  atKarmaWeReNotJustAboutWork:
    'At Karma, we’re not just about work; we’re about creating an environment where everyone’s input is valued and where each day brings a new opportunity for growth and impact.',
  beAPartOfTheJourney: 'Be a part of the journey',
  noPositionsAvailable: 'No positions available',
  apply: 'Apply',
  dontSeeAnythingThatFitsYourSkillSet:
    "Don't see anything that fits your skill set? Don't let that stop you from reaching out! If you think you can help us grow, send an email to",
  ifYouReReadyToMakeAnImpact:
    'If you’re ready to make an impact and thrive in a setting that values speed, fun, and collaboration, Karma might be your next great adventure.',
  exploreOurCareerOpportunities:
    'Explore our career opportunities and find out how you can contribute to our exciting journey ahead. Join us, and let’s achieve greatness together!',
  welcomeToKarma:
    'Welcome to Karma—where technology meets savvy shopping. Join us in our mission to revolutionize the way you shop, ensuring every purchase is just right for you.',
  empoweringSmartShopping: 'Empowering Smart Shopping:\nThe Karma Story',
  ourMissionPart1:
    'At Karma, we believe in empowering shoppers to make wise and informed purchasing decisions. Founded in 2015, our mission has always been to guide consumers toward smarter, more responsible shopping. As both a browser extension and mobile app, Karma harnesses the power of advanced AI to enhance your shopping experience. This technology predicts the optimal time to make a purchase, ensuring you get the best deal possible.',
  ourMissionPart2:
    'Over the years, Karma has continuously evolved, integrating cutting-edge technology to keep pace with the dynamic e-commerce landscape. We take pride in helping our users avoid buyer’s remorse and overspending by providing them with the tools they need to shop confidently!',
  hearFromOurUsers: 'Hear from our users',
  karmaPatents: 'Karma patents',
  systemAndMethodForPreauthorizing: 'System and method for preauthorizing database transaction commits',
  systemAndMethodForScraping: 'System and method for near real time web scraping',
  startYourShoppingJourney: 'Start your shopping journey',
  searchForItemBrandStore: 'Search for an item, brand or store',
  quillDisclosure: 'HP, Epson, & Samsung excluded',
  theKButtonIsInMyWay: 'The K button is in my way',
  iOnlyInstalledItForAOneTimeDeal: 'I only installed it for a one-time deal',
  iOnlyInstalledItForAOneTimeDealTitle: 'We love a savvy shopper!',
  iOnlyInstalledItForAOneTimeDealDescription:
    'But did you know Karma helps you <1>save every<2/> time you shop?</1> No extra effort needed.<2/> Why not keep it around?',
  itWasntHelpful: 'It wasn’t helpful',
  itWasntHelpfulTitle: 'Karma’s got your back!',
  itWasntHelpfulDescription:
    'We track <1>price drops, restocks, and give<2/> you Cash Back.</1><2/> In the US? We’ll show you the <1>best credit card rewards at checkout.</1><2/> Give it another shot?',
  iUseOtherShoppingExtensions: 'I use other shopping extensions',
  iUseOtherShoppingExtensionsDescription:
    'But don’t forget, Karma finds <1>hidden price drops</1><2/> and <1>exclusive rewards</1> that others might miss.<2/> Why not double up?',
  tooManyCouponPopupsAtCheckout: 'Too many coupon pop-ups at checkout',
  cookies:
    'Karma uses cookies to ensure you see the things we think you’ll love the most. <2>Click here</2> to read our full policy',
  decline: 'Decline',
  confirmYourCookieSettings: 'Confirm your cookie settings',
  youControlHowWeUseCookies:
    'You get to control how we use cookies on each device and browser you use. These settings will apply to your current device when you use {{browser}}.',
  whatAreCookies: 'What are cookies?',
  cookiesAndTrackingTechnologies:
    'Cookies and tracking technologies are small text files stored on your device when you use a web browser. Some cookies are essential for you to use our site, while other cookies collect data about your browsing habits. We use this data to give you the best experience.',
  marketing: 'Marketing',
  weUseMarketingCookies: "We use marketing cookies to deliver ads we think you'll like.",
  marketingCookiesLet: 'For example, marketing cookies let us show you personalized ads based on your interests.',
  performance: 'Performance',
  weUsePerformanceCookies: 'We use performance cookies to understand how you interact with our site.',
  performanceCookiesHelp:
    'For example, performance cookies help us learn which parts are the most popular and which parts we could improve for you.',
  functional: 'Functional',
  weUseFunctionalCookies: 'We use functional cookies to customize your experience.',
  functionalCookiesLet:
    'For example, functional cookies let us remember your preferences like language, country or region, and text sizes.',
  essential: 'Essential',
  weUseEssentialCookies: 'We use essential cookies to make our site work for you.',
  essentialCookiesLet:
    'For example, essential cookies let you securely sign in and browse our site. These cookies help us keep your account safe and prevent fraud.',
  youCanReadMoreAboutCookies: 'You can read more about how we use cookies in our <2>Cookie Statement</2>.',
  confirmCookieSettings: 'Confirm Cookie Settings',
  noMinimumOrderValue: 'No minimum order value',
  fromToDays: '{{value, number}} to {{value2, number}} days',
  headerLogin: 'Karma | Login',
  headerOnboarding: 'Karma | Onboarding',
  yourDataHasBeenRemoved: 'Your data has been successfully removed.',
  confirmationCode: 'Confirmation code: {{code}}',
  startOnlineShopping: 'Start online shopping to see Karma in action',
  trendingOffers: 'Trending Offers',
  useCode: 'Use code: {{code}}',
  getDeal: 'Get Deal',
  buyNow: 'Buy now',
  trendingCoupons: 'Trending Coupons',
  searchResultsFor: 'Search Results for "{{search}}"',
  trendingItems: 'Trending Items',
  curateSmartWishlists: 'Curate Smart wishlists',
  karmaWillLetYouKnow: 'Karma will let you know when the items you want go on sale or are back in stock',
  saveEarnAtCheckout: 'Save & Earn at checkout',
  weApplyBestCoupon:
    'We’ll automatically apply the best coupon codes on the web at checkout & reward for your purchase on 1000’s of stores',
  scanToGetApp: 'Scan to get the app',
  unlockYourCreditCardsBenefits: 'Unlock your credit cards benefits',
  easilyCompareBetweenCreditCards:
    'Easily compare between the credit cards rewards to choose the best one to use at checkout',
  emailPositiveFeedbackThankYou: 'Thank you for your feedback!',
  emailPositiveFeedbackYourExperience: 'Share your experience by leaving a review on your platform of choice:',
  headerPositiveFeedback: 'Karma | Email Positive Feedback',
  headerNegativeFeedback: 'Karma | Email Negative Feedback',
  emailNegativeFeedbackTitle: 'We’re listening, share your feedback',
  emailNegativeFeedbackSubTitle:
    'To help us resolve the issue faster, please let us know what’s wrong with the notification',
  emailPriceDoesNotMatch: 'The email price does not match the website price',
  emailItemNotOnSale: 'The item is not on sale',
  emailItemOutOfStock: 'The item is out of stock',
  emailLinkNotWorking: 'The link is not working',
  emailPromoCodeNotAccepted: 'Promo code is not accepted by store',
  emailPromoCodeOnPage: 'Couldn’t apply the promo codes on the page',
  emailOther: 'Other',
  headerNegativeFeedbackSuccess: 'Karma | Negative Feedback Success',
  emailNegativeFeedbackSuccessTitle: 'Thank you for submitting your feedback!',
  emailNegativeFeedbackSuccessSubTitle: 'Our support team is on it, and we’ll be sure to update you soon.',
  enterValue: 'Enter value...',
  httpErrorOccurred: 'An error occurred, please try again later',
  everWonderWhichCreditCard: 'Ever wonder which credit card to use to get the best rewards?',
  doNotWorryYouCovered: 'Don’t worry, we’ve got you covered!',
  linkYourCardType: 'Link your card type – No card numbers, no personal info needed.',
  shopLikeAlways: 'Shop like always – See your rewards instantly at checkout.',
  compareAndDecide: 'Compare and decide – Easily choose the best card to maximize your rewards.',
  exclusivelyForUS: '*Exclusively for US users – try it today!',
  clientUninstallRespTitle: 'Thank You for Trying Karma!',
  clientUninstallRespTitle1: 'We appreciate you giving Karma a shot.',
  clientUninstallRespTitle2: 'While you’re off hunting for deals on your own, remember—we’re always here',
  clientUninstallRespTrackPriceDrop: 'Track price drops so you never overpay',
  clientUninstallRespHiddenDisc: 'Find hidden discounts and Cash Back',
  clientUninstallRespAlert: 'Alert you when items restock',
  clientUninstallRespShowBest: 'Show the best credit card perks at checkout',
  clientUninstallRespUSOnly: '*US only',
  clientUninstallRespWhantKeep: 'Want to keep saving?',
  otherTitle: 'We’d love to know\n why you’re leaving!',
  noRelevantDealsInMyFavedStoresTitle: 'We get it, some stores don’t always\n have discounts.',
  theKbuttonWasInMyWayTitle: 'You can move or minimize\n it in settings',
  iUseOtherShoppingExtensionsTitle: 'We respect the hustle\n saving money is the goal!',
  couponsAndPromosHub: 'Coupons and Promos Hub',
  weLoveToKnowYou: "We'd love to get to know you better",
  takesLessThanMinute: 'Takes less than a minute, and helps us improve. Your answers stay private—promise.',
  skip: 'Skip',
  nonBinary: 'Non-binary',
  embeddedLoyaltyLearnMoreBtn: 'Learn more',
  embeddedLoyaltyStartTodayBtn: 'Start Today',
  embeddedLoyaltyGetStartedTitle: 'Get Started Today',
  embeddedLoyaltyGetStartedDescription:
    'Don’t miss the chance to transform your customer experience. Join the brands leveraging Karma’s White-Label Embedded Loyalty Platform to build lasting relationships and drive growth.',
  embeddedLoyaltyGetStartedBtn: 'Contact Us',
  embeddedLoyaltyHeader: "Elevate Your Banking Ecosystem with Karma's Loyalty Solution",
  embeddedLoyaltyHeaderDescription:
    'Karma’s <1>white-label embedded loyalty platform</1> positions your bank as the leader in delivering personalized cashback, rewards, and coupon opportunities for your customers whenever they shop – meeting their growing demand for <1>convenience, value, and engagement</1>, while ensuring that your brand is always <1>front and center</1>.',

  embeddedLoyaltyRewards: 'Empowering Banks to Deliver Seamless Rewards With Every Purchase',
  embeddedLoyaltyRewardsDescription:
    'Transform customer interactions into meaningful experiences while enhancing brand loyalty and driving valuable engagements.',
  embeddedLoyaltyChooseKarmaTitle: 'Why Choose Karma’s\n White-Label Loyalty Platform?',
  embeddedLoyaltyChooseKarmaDescription:
    'Our platform is built to meet the highest industry standards, fitting naturally into your ecosystem while keeping your brand in the forefront.',
  embeddedLoyaltyFeaturesTitle: 'Key Features & Benefits',
  embeddedLoyaltyAllFeaturesBtn: 'View all of our features',
  viewAllFeatures: 'View All Features',

  embeddedLoyaltyWhatSetsTitle: 'What Sets Us Apart?',
  embeddedLoyaltyWhatSetsDescription:
    'Unlike other solutions, Karma’s platform is designed to seamlessly blend into your brand experience. By focusing on ease of use and advanced technology, we help you foster deeper connections with your customers, ensuring loyalty programs become a natural extension of your business.',

  embeddedLoyaltyPlatformCaption: 'Effortless Integration for Banks',
  embeddedLoyaltyPlatformDescription:
    'Karma’s platform fits naturally into your ecosystem, offering a turnkey solution that minimizes technical complexity.',
  embeddedLoyaltyPlatformCaption2: 'Boost Brand Loyalty with White-Label Solutions',
  embeddedLoyaltyPlatformDescription2:
    'Keep your brand front and center. Karma ensures that every interaction reflects your identity, strengthening customer trust and loyalty.',
  embeddedLoyaltyPlatformCaption3: 'Bank-Grade Security and Compliance',
  embeddedLoyaltyPlatformDescription3:
    'Built to meet the highest industry standards, Karma’s platform ensures complete compliance with PCI and SOC certifications.',

  embeddedLoyaltyFeaturesTitle1: 'Streamlined Payment Autofill',
  embeddedLoyaltyFeaturesDescription1:
    'Simplify transactions with auto-filled payment details, keeping your card “top-of-wallet”. This feature minimizes checkout friction, ensuring your card is the preferred choice every time.',
  embeddedLoyaltyFeaturesTitle2: 'Upsell & Cross Sell Financial Products',
  embeddedLoyaltyFeaturesDescription2:
    'Easily offer your customers new financial products such as virtual cards, installments, new (issuance) credit card offers, savings accounts, or other bank products directly from the branded browser widget - live exactly when needed.',
  embeddedLoyaltyFeaturesTitle3: 'Earn & Redeem Points at Checkout',
  embeddedLoyaltyFeaturesDescription3:
    'Allow customers to seamlessly use their loyalty points as payment, enhancing the value of your rewards program at checkout. Customers can redeem points directly during their shopping journey, encouraging frequent card usage and building deeper loyalty.',
  embeddedLoyaltyFeaturesTitle4: 'Custom Shopping Portals & Offer Walls',
  embeddedLoyaltyFeaturesDescription4:
    'Offer your customers an intuitive shopping directory with exclusive deals from more than 100,000 global merchants, including travel and even meals. Whether through pre-configured solutions or customized integrations, Karma creates a hub for savings and rewards tailored to your brand, which can be hosted directly in your banking app, customer account page or behind a dedicated URL.',
  embeddedLoyaltyFeaturesTitle5: 'Targeted Cashback Offers & Notifications',
  embeddedLoyaltyFeaturesDescription5:
    'Delight customers with timely cashback notifications while they shop online. Karma’s platform presents offers at critical points in the purchase journey, increasing conversions and satisfaction. Notify customers via email, text or push notifications of price reductions or back-in-stock items for saved products and shopping lists that your customers have saved and curated.',
  embeddedLoyaltyResultsTitle: 'We Drive Results.',
  embeddedLoyaltyResultsDescription: 'Here’s how:',

  embeddedLoyaltyResultsCaption1: 'Comprehensive Merchant Network',
  embeddedLoyaltyResultsDescription1:
    'Access offers from a vast affiliate network, connecting your customers to over 100,000 global merchants.',

  embeddedLoyaltyResultsCaption2: 'Increased Engagement and Revenue',
  embeddedLoyaltyResultsDescription2:
    'By embedding rewards into your ecosystem, customers are incentivized to shop, increasing program adoption and driving incremental revenue.',

  embeddedLoyaltyResultsCaption3: 'Enhanced Customer Retention',
  embeddedLoyaltyResultsDescription3:
    'Offering meaningful savings and rewards builds loyalty, ensuring your customers stay engaged with your services.',
  embeddedLoyalty: 'Embedded Loyalty',
  headerEmbeddedLoyalty: 'Karma | Embedded Loyalty',
  headerSwe: 'Karma | SWE',
  gotKarmaStep1Title: 'Tap the <1/> on the left of <2/> the address bar. ',
  gotKarmaStep1Description: 'This is where all the magic is hidden.',
  gotKarmaStep2Title: 'Select ‘Manage Extensions’ <1/>',
  gotKarmaStep2Description: 'You’re getting warmer...',
  gotKarmaStep3Title: 'Toggle on ‘Karma’ <1/>',
  gotKarmaStep3Description: 'You found us! Now turn us on.',
  gotKarmaStep4Title: 'Tap <1/>',
  gotKarmaStep4Description: 'Just grant access - you’re so close!',
  gotKarmaStep5Title: 'Pick ‘Always Allow’ <1/>',
  gotKarmaStep5Description: 'Karma will make sure you always get the best deal.',
  gotKarmaStep6Title: 'Pick ‘Always Allow On Every Website’',
  gotKarmaStep6Description: 'Karma will find you the lowest prices everywhere.',
  downloadKarma: 'Download Karma!',
  sweQuestion1: 'How do I get the mobile extension?',
  sweAnswer1:
    'To enable the mobile extension, you have to start by downloading the app. Once you had that, just go into Safari, activate Karma, and grant access! For a more detailed explanation - look right above 🙂.',
  sweQuestion2: 'How does the Safari extension work?',
  sweAnswer2:
    "Karma automatically works in the background while you shop. It's a smart shopping companion that searches the web for coupons, deals, and lower prices. If you tell Karma what you're interested in, it will know to keep you in the loop on that specific item or offer.",
  sweQuestion3: 'Why do I need the Karma App to use the Safari Extension?',
  sweAnswer3:
    "Like other mobile extensions, the Safari extension is powered by the Karma App. They are bundled together in one download. So, if you already have the app, you're a step ahead!",
  sweQuestion4: 'Is the mobile extension available for Android?',
  sweAnswer4:
    "The mobile extension isn't available for Android yet, but the Karma App is! Get it in the Google Play Store now!",
  sweQuestion5: "Is my data secure on Karma's Safari extension?",
  sweAnswer5:
    'We take your privacy and security extremely seriously. Read more about what we do to keep your information safe.',

  sweScanBoxHeaderTitle: 'Karma for iPhone',
  sweScanBoxHeaderDescription:
    'The an all-in-one shopping assistant that automatically saves you time and money - now right at the tip of your fingers.',
  sweScanBoxTitle: 'Get Started on Mobile Safari',
  sweScanBoxDescription: 'Our extension is available exclusively in Mobile Safari.',
  sweScanBoxOpenSafari: 'Open this page in Safari on your iPhone.',
  sweScanBoxScanTheQrCode: 'Scan the QR code below to download the Karma app and activate the extension.',
  sweScanBoxOpenCamera: 'Open your camera on your iPhone to scan QR code.',
  stepsToSavingTitle: 'Got Karma?\n Let’s Walk You Through The Steps to Savings',
  discoverTopPicks: 'Discover Top Picks',
  topPicksAt: 'Top Picks at {{brand}}',
  games: 'Games',

  scheduleADemo: 'Schedule a demo',
  partnershipsReadyToShopTitle: 'Reach Millions of\nReady-to-Shop Users',
  partnershipsReadyToShopDescription: 'Tap into our engaged audience and drive real results.\nLet’s grow together.',
  partnershipsStat1Title: 'Shoppers',
  partnershipsStat2Title: 'Saved Items',
  partnershipsStat3Title: 'Newsletter Subscribers',

  partnershipsTurnShoppersTitle: 'Turn Shoppers into Buyers',
  partnershipsTurnShoppers1Title: '500K daily active users',
  partnershipsTurnShoppers3Title: 'Top Geos: US, UK, EU, CA, APAC',
  partnershipsTurnShoppers4Title: '85% of shoppers plan their next\n purchase with us',
  partnershipsTurnShoppers5Title: '$185 AOV',
  partnershipsTurnShoppers6Title: '200K+ partnered brands',

  partnershipsStrategicTitle: 'Strategic Brand Placements',
  partnershipsStrategicCaption1: 'Email Newsletter',
  partnershipsStrategicCaption2: 'Email Banner',
  partnershipsStrategicCaption3: 'Daily Featured',
  partnershipsStrategicCaption4: 'Trending Offers',
  partnershipsStrategicCaption5: 'Blog Content',
  partnershipsStrategicCaption6: 'Popular Stores',

  partnershipsExplorerTitle: 'Explore Our Case Studies',
  caseStudyTravelTitle: 'Travel',
  caseStudyTravelDescription:
    'Travel shoppers consistently generate some of the highest AOVs in ecommerce, with 65% of all bookings expected to happen online by 2026.',
  caseStudyLuxuryTitle: 'Luxury',
  caseStudyLuxuryDescription:
    'Millennials and Gen Z now drive most of the growth in luxury and are expected to represent up to 80% of global purchases by 2030.',
  caseStudyTechTitle: 'Tech',
  caseStudyTechDescription:
    'Savvy products means savvy shoppers. Electronics consumers compare hard, spend big, and respond strongly to well-timed offers.',
  caseStudyBeautyTitle: 'Beauty',
  caseStudyBeautyDescription:
    'Beauty shoppers are highly engaged, mobile-first, and influenced by social content - making this one of the most dynamic categories in ecommerce.',
  caseStudyHomeTitle: 'Home',
  caseStudyHomeDescription: 'High-consideration purchases + high AOV = every incremental sale counts.',
  caseStudyMarketplaceTitle: 'Marketplace',
  caseStudyMarketplaceDescription:
    'Around 72% of global ecommerce revenue now flows through marketplaces - brands that stand out here win visibility and scale.',
  caseStudyPetsTitle: 'Pets',
  caseStudyPetsDescription:
    'Loyalty-driven buyers who return again and again - pet owners show some of the highest repeat purchase rates across categories.',
  caseStudySportsOutdoorsTitle: 'Sports & Outdoors',
  caseStudySportsOutdoorsDescription:
    'Fitness-driven shoppers are mission-oriented and conversion-ready. Engagement spikes during key seasonal moments and product drops.',
  caseStudyFashionTitle: 'Fashion',
  caseStudyFashionDescription: '1 in 5 fashion buyers also purchase from Beauty or Home categories within 30 days.',
  partnershipsGetStartedTitle: 'Get Started Today',
  partnershipsGetStartedDescription:
    'Join a network of top brands leveraging Karma to reach millions of heavy shoppers.\n For more information contact <1>partnerships@karmanow.com</1>',
  signIn: 'Sign In',
  couponCodesPromoCodesTitle: '{{Brand}} Promo Codes & Coupons',
  couponCodesPromoCodesCardTitle: 'Unlock Real-Time {{Brand}} Promo Codes - Verified Daily',
  couponCodesPromoCodesCardDescription:
    "Karma tracks, verifies, and refreshes promo codes in real time so you never miss a deal - whether you're shopping tech, home essentials, or the latest fashion finds. Bookmark this page and check back often for fresh savings that actually work. One click, instant value, no effort.",
  couponCodesHelpTitle: 'How Karma Helps You Find the Best {{Brand}} Promo Codes',
  couponCodesHelpCard1Title: 'Why Karma is the best place for real-time promo codes',
  couponCodesHelpCard1Description:
    "Karma tracks deals in real time, ensuring you see working promo codes the moment they're available. No endless searching, no expired links—just fresh, reliable discounts curated for shoppers who want to save smart with zero hassle.",
  couponCodesHelpCard2Title: 'How We Verify Codes',
  couponCodesHelpCard2Description:
    "Every promo code on Karma is tested before it's displayed, and continuously monitored throughout the day. If a code stops working, we remove it instantly so you never waste time trying expired or misleading coupons. Our verification system keeps your savings accurate, clean, and frustration-free.",
  couponCodesHelpCard3Title: 'How to Apply {{Brand}} Promo Codes (Step-by-Step)',
  couponCodesHelpCard3Step1: 'Browse this list and choose a code you want to use',
  couponCodesHelpCard3Step2: 'Click Get Code or Copy Code',
  couponCodesHelpCard3Step3: "You'll be taken to the shop automatically",
  couponCodesHelpCard3Step4: 'Add your items to cart',
  couponCodesHelpCard3Step5: 'Paste the code into the Promo/Discount box at checkout',
  couponCodesHelpCard3Step6: 'Enjoy instant savings on your order 🎉',
  couponCodesHelpCard4Title: 'Why {{Brand}} Promo Codes Expire Quickly',
  couponCodesHelpCard4Description:
    "Discounts are time-sensitive and heavily demand-driven. Many deals are tied to inventory, flash sales, or seller promotions, meaning they can disappear within hours. That's why Karma refreshes codes around the clock, to keep you ahead of the expiration clock.",
  couponCodesHelpCard5Title: 'Other Ways to Save Money on {{Brand}}',
  couponCodesHelpCard5Description:
    'Promo codes are just one part of the savings puzzle. With Karmanow, you can also save through:',
  couponCodesHelpCard5ListItem1: 'Price-drop alerts',
  couponCodesHelpCard5ListItem2: 'Back-in-stock notifications',
  couponCodesHelpCard5ListItem3: 'Cashback and coupon stacking opportunities',
  couponCodesHelpCard5ListItem4: 'Seasonal & holiday sale tracking',
  couponCodesHelpCard5Conclusion: 'More savings → Less effort → Smarter shopping.',
  couponCodesTodaysTopTitle: 'Today’s Top {{Brand}} Promo Codes',
  couponCodesTodaysTrendingPromoCodes: "Today's Trending Promo Codes",
  viewMoreDeals: 'View More Deals',
  getPromoCode: 'GET PROMO CODE',
  promoCodeCopied: 'Code copied',
  neverMissADeal: 'Never miss a deal',
  subscribeToOurNewsletter: 'Subscribe to our newsletter and get notified about amazing discounts.',
  subscribing: 'Subscribing...',
  subscribe: 'Subscribe',
  newsletterSubscriptionSuccess: 'Successfully subscribed to newsletter!',
  newsletterSubscriptionError: 'Failed to subscribe. Please try again.',
  couponCodesQuestionsSubtitle: "Got questions about Karma? We've got answers.",
  couponCodesQuestionsQ1: 'How often are promo codes updated?',
  couponCodesQuestionsA1: 'We update this page daily to ensure you get the latest deals.',
  couponCodesQuestionsQ2: 'Can I use multiple promo codes?',
  couponCodesQuestionsA2:
    "Depends on the brand - some allow you to do so while others don't. But most coupons can be combined with other discounts!",
  couponCodesQuestionsQ3: 'Do promo codes expire?',
  couponCodesQuestionsA3: 'Yes, most codes have a limited time frame, so check the expiration date before using.',
  couponCodesQuestionsQ4: 'Is Karma free to use?',
  couponCodesQuestionsA4: '100% free — no sign-up required to browse codes or save money.',
  couponCodesQuestionsQ5: 'Are promo codes verified?',
  couponCodesQuestionsA5: 'Yes - Karmanow verifies codes in real time to eliminate dead or fake discounts.',
  verified: 'Verified',
  couponCodesShoppingTipsTitle: '{{Brand}} Shopping Tips',
  couponCodesShoppingTipsSubtitle: "Shopping at {{Brand}}? Here's how to save smarter:",
  couponCodesDiscountsOfDayTitle: 'What To Buy At {{Brand}} Now',
  couponCodesDiscountsOfDaySubtitle: 'Biggest Discounts of the Day',
  couponCodesDiscountsOfDayNeverMissADeal: 'Never miss a deal',
  couponCodesDiscountsOfDaySubscribeToOurNewsletter:
    'Subscribe to our newsletter and get notified about amazing discounts.',
  couponCodesDiscountsOfDaySubscribing: 'Subscribing...',
  couponCodesDiscountsOfDaySubscribe: 'Subscribe',
  couponCodesPopularBrandsTitle: 'Promo Codes From Other Popular Brands',
  couponCodesPopularBrandsSubtitle:
    'Looking for promo codes from other stores? Click on any brand to see the latest verified promo codes and savings.',
  headerKarmaEarn: 'Karma | Karma Earn',
  earnNowShopLater: 'Earn now. Shop later.',
  startEarningBtn: 'Start Earning!',
  startEarningDescription: 'Turn the things you already do into real rewards, with more ways to earn in one place.',
  earn: 'Earn',
  myActivity: 'My Activity',
  playGames: 'Play games',
  answerSurveys: 'Answer surveys',
  karmaEarnSurveyTitle1: 'A quick surprise survey',
  karmaEarnSurveyTitle2: 'Have fun with a quick check-in',
  karmaEarnSurveyTitle3: 'Share your opinion — earn Karma',
  karmaEarnSurveyTitle4: 'Your voice matters',
  karmaEarnSurveyTitle5: 'Easy questions, easy rewards',
  karmaEarnSurveyTitle6: 'Tell us what you think',
  karmaEarnSurveyTitle7: 'A friendly little survey',
  karmaEarnSurveyTitle8: 'Quick thoughts, real rewards',
  karmaEarnSurveyTitle9: "We'd love your take",
  karmaEarnSurveyTitle10: 'Relax — just a few questions',
  scanReceipt: 'Scan receipt',
  watchVideos: 'Watch videos',
  offers: 'Offers',
  device: 'Device',
  ios: 'iOS',
  android: 'Android',
  win_mac: 'Win/Mac',
  playNow: 'Play now',
  answer: 'Answer',
  rewardDetails: 'Reward details',
  maxPerTask: 'Max per task',
  nothingToEarnHere: 'Nothing to earn here yet',
  noEarningOpportunities:
    'We don’t have any earning opportunities in this category right now.\nNew ways to earn points are added regularly.',
  yourOffersWillShow: 'Your offers will show up here',
  onceYouStartOffer:
    'Once you start an offer, you’ll be able to track your progress here.\nJump in and start earning coins.',
  startEarningKarmaCoins: 'Start earning coins',
  gameTasks: 'Game tasks',
  seeMore: 'See more',
  chooseWhereYouPreferEarn: 'Choose where you prefer to earn',
  mobile: 'Mobile',
  desktop: 'Desktop',
  youCanNotEarnIf: 'You cannot earn if you installed it before',
  useYourMobileDevice: 'Use your mobile device to complete this offer',
  scanQrCode: 'Scan the QR code',
  completeIn: 'Complete in <1>{{days, number}} day</1> to qualify',
  completeIn_plural: 'Complete in <1>{{days, number}} days</1> to qualify',
  vpnSpotted: 'VPN Spotted',
  yourVpnMakingThingsComplicated:
    "Your VPN is making things complicated.\nWe can’t technically track your progress or\nreward your Karma Earn wins while it's active.",
  pleaseDisableYourVpn:
    'Please <1>disable your VPN</1> and refresh Let’s get\nback to making that money feel effortless',
  refresh: 'Refresh',
  genres: 'Genres',
  actionAdventure: 'Action & Adventure',
  strategyRolePlaying: 'Strategy & Role-Playing',
  puzzleLogic: 'Puzzle & Logic',
  cardsBoardCasino: 'Cards, Board & Casino',
  casualLifestyle: 'Casual & Lifestyle',
  sports: 'Sports',
  educational: 'Educational',
  thisOfferNotAvailable: 'This offer is not available at this moment',
  iosGoals: 'iOS goals',
  androidGoals: 'Android goals',
  webGoals: 'Web goals',
  bonusMissions: 'Bonus missions',
  seeOtherOffers: 'See other offers',
  checkRewards: 'Check rewards',
  somethingWentWrong: 'Something went wrong',
  keyPoints: 'Key points',
  completeThisSteps: 'Complete this steps',
  giftCardSuccessTitle: "You're all set!",
  giftCardSuccessMessage: 'Your <strong>{{name}}</strong> gift card is on its way - check your inbox shortly.',
  giftCardErrorTitle: 'Something went wrong.',
  giftCardErrorMessage: "Please reach out to support and we'll get this sorted for you.",
  usd: '${{value, number}}',
  id: '{{id, clearNumber}}',
  pendingDescKarmaEarn: 'Your Karma Earn reward is pending and will be confirmed within 72 hours.',
  youHaveInYourWallet: 'You have in your wallet:',
  karmaGivesModalTitlePointsBefore: "Here's",
  karmaGivesModalTitlePointsAfter: 'FREE to Get You Started',
  details: 'Details',
  earnNow: 'Earn now',
  coins: 'Coins',
  cashOut: 'Cash out',
  redeemGiftCards: 'Redeem Gift Cards',
  theMinimumAmountToRedeem: 'The minimum amount to redeem is {{coins}} Coins/{{usd}}',
  youCanRedeemMaxPerYear: 'You can redeem a maximum of {{coins}} Coins/{{usd}} per physical year',
  minimumAmountWithWaitingPeriod:
    'The minimum amount to redeem is {{coins}} Coins/{{usd}} and you must wait {{days}} days from your first earning before you can redeem',
  youMustWaitDays: 'You must wait {{days}} days from your first earning before you can start redeeming',
  verifyPayPal: 'Verify PayPal',
  validUntil: 'Valid until',
  youHaveWithdrawnCashBack: 'You’ve withdrawn your Cash Back',
  toAccessYourEarnings: 'To access your earnings, please log in to your PayPal',
  canNotCashOut: "Can't cash out right now",
  youHaveGiftCardRedemptionProgress:
    "You have a gift card redemption\nin progress.\nTo cash out to PayPal, you'll need to cancel it first.",
  cancelGiftCard: 'Cancel Gift Card',
  dismiss: 'Dismiss',
  pleaseTryAgain: 'Please try again',
  success: 'Success',
  weSentYouEmail: 'We’ve sent you an email',
  pleaseVerifyYourAccount: 'Please verify your account and try again',
  paused: 'Paused',
  myEarnings: 'My earnings',
  home: 'Home',
  categories: 'Categories',
  mostPopular: 'Most popular',
  allGiftCards: 'All Gift Cards',
  storeOnly: 'Store only',
  onlineOnly: 'Online only',
  onlineAndStores: 'Online & Stores',
  expWithDot: 'Exp.',
  where: 'Where?',
  unlimited: 'Unlimited',
  yearsShort: 'yr',
  monthsShort: 'mo',
  redeem: 'Redeem',
  howMuch: 'How much?',
  notAvailableInYourLocation: 'Not available in \nyour location',
  weDoNotCurrentlyOfferGiftCards: 'We don’t currently offer gift cards \nin your location',
  redeemWithPayPal: 'Redeem with PayPal',
  noGiftCardsFound: 'No gift cards found',
  tryAnotherCategory: 'Try another category or check \nback soon',
  confirmationEmailSentTo: 'Confirmation email sent to \n{{email}}',
  resendEmail: 'Resend email',
  iChangedMyMind: 'I changed my mind',
  areYouSure: 'Are you sure?',
  thisWillCancelRedemption: 'This will cancel the redemption to \ngift card process',
  yesCancelRedemption: 'Yes, cancel redemption',
  neverMind: 'Never mind',
  verificationEmailSent: 'Verification email sent',
  weSentVerificationEmailTo: 'We sent a verification email to \n<strong>{{email}}</strong>.',
  pleaseVerifyYourEmail: 'Please verify your email to receive your Gift Card.',
  didNotGetEmail: 'Didn’t get the email?',
  checkYourSpam: 'Check your spam or promotions folder, \nor contact support.',
  contactSupport: 'Contact support',
  filterCategories: 'Filter categories',
  filter: 'Filter',
  filters: 'Filters',
  redeemedToGiftCard: 'Redeemed to gift card',
  yourItemFromIsNotificationHistory: 'Your item from <b>{{shopName}}</b> is <b>{{marker}}</b>',
  wallet: 'Wallet',
  category: 'Category',
  showGames: 'Show games',
  reset: 'Reset',
};
